(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[853],{

/***/ 57867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _instanceof = (__webpack_require__(53778)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(54363)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var _loadable = _interop_require_default(__webpack_require__(8450));
function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function (param) {
      var error = param.error,
        isLoading = param.isLoading,
        pastDelay = param.pastDelay;
      if (!pastDelay) return null;
      if (false) {}
      return null;
    }
  };
  // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first
  if (_instanceof(dynamicOptions, Promise)) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
  } else if (typeof dynamicOptions === "function") {
    loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === "object") {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  }
  // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
  loadableOptions = _extends({}, loadableOptions, options);
  // Error if Fizz rendering is not enabled and `suspense` option is set to true
  if (false) {}
  if (loadableOptions.suspense) {
    if (false) {}
    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  }
  // coming from build/babel/plugins/react-loadable-plugin.js
  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  }
  // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly
  if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }
    delete loadableOptions.ssr;
  }
  return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules;
  // This check is necessary to prevent react-loadable from initializing on the server
  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }
  var Loading = loadableOptions.loading;
  // This will only be rendered on the server side
  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
  Object.defineProperty(exports.default, "__esModule", {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map

/***/ }),

/***/ 18546:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map

/***/ }),

/***/ 8450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _classCallCheck = (__webpack_require__(13749)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(52336)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(54363)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(4858)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(82684));
var _loadableContext = __webpack_require__(18546);
var useSyncExternalStore = ( true ? __webpack_require__(82684) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}
function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
  var init = function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }
    return subscription.promise();
  };
  var useLoadableModule = function useLoadableModule() {
    init();
    var context = _react.default.useContext(_loadableContext.LoadableContext);
    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  };
  var LoadableImpl = function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);
    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  };
  var LazyImpl = function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  };
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);
  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */
  var subscription = null;
  // Server only
  if (false) {}
  // Client only
  if (!initialized && "object" !== "undefined") {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iteratorNormalCompletion = true,
          _didIteratorError = false,
          _iteratorError = undefined;
        try {
          for (var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var moduleId = _step.value;
            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }
  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
  LoadableComponent.preload = function () {
    return init();
  };
  LoadableComponent.displayName = "LoadableComponent";
  return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);
    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }
  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;
      this._clearTimeouts();
      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var ref = this,
        res = ref._res,
        opts = ref._opts;
      if (res.loading) {
        if (typeof opts.delay === "number") {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }
        if (typeof opts.timeout === "number") {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }
      this._res.promise.then(function () {
        _this._update({});
        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});
        _this._clearTimeouts();
      });
      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);
      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this = this;
      this._callbacks.add(callback);
      return function () {
        _this._callbacks.delete(callback);
      };
    }
  }]);
  return LoadableSubscription;
}();
function Loadable(opts) {
  return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
  var promises = [];
  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }
  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}
Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};
Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function () {
      initialized = true;
      return resolvePreload();
    };
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};
if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map

/***/ }),

/***/ 51774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(57867);

/***/ }),

/***/ 69442:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurzy/[slug]",
      function () {
        return __webpack_require__(52642);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useGetLecture; }
/* harmony export */ });
/* unused harmony export queryKeys */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99167);




var P = "lecture";
var queryKeys = {
    get: function(lectureId) {
        return [
            P,
            lectureId.toString()
        ];
    }
};
var fetchLecture = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lectureId, preview) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authFetch */ .SH(_api__WEBPACK_IMPORTED_MODULE_1__/* .lectureUrl */ .$f(lectureId, preview))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw Error("Nepodarilo sa nač\xedtať lekciu");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchLecture(lectureId, preview) {
        return _ref.apply(this, arguments);
    };
}();
var useGetLecture = function(lectureId, preview) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKeys.get(lectureId), function() {
        return fetchLecture(lectureId, preview);
    }, {
        cacheTime: 60 * 60 * 1000,
        staleTime: 30 * 60 * 1000
    });
};


/***/ }),

/***/ 7967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86854);
/* harmony import */ var react_syntax_highlighter_dist_cjs_languages_prism_javascript__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65886);
/* harmony import */ var react_syntax_highlighter_dist_cjs_languages_prism_kotlin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15222);
/* harmony import */ var react_syntax_highlighter_dist_cjs_languages_prism_python__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94753);
/* harmony import */ var react_syntax_highlighter_dist_cjs_styles_prism__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65292);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99216);








// all languages we want to syntax highlight need to be imported and registered
// https://github.com/react-syntax-highlighter/react-syntax-highlighter#light-build
react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].registerLanguage */ .Z.registerLanguage("javascript", react_syntax_highlighter_dist_cjs_languages_prism_javascript__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].registerLanguage */ .Z.registerLanguage("kotlin", react_syntax_highlighter_dist_cjs_languages_prism_kotlin__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"].registerLanguage */ .Z.registerLanguage("python", react_syntax_highlighter_dist_cjs_languages_prism_python__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
var SyntaxHighlighter = function(param) {
    var children = param.children, language = param.language, customStyle = param.customStyle;
    var isLightTheme = (0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)().isLightTheme;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        language: language,
        style: isLightTheme ? react_syntax_highlighter_dist_cjs_styles_prism__WEBPACK_IMPORTED_MODULE_7__.vs : react_syntax_highlighter_dist_cjs_styles_prism__WEBPACK_IMPORTED_MODULE_7__/* .vscDarkPlus */ .YC,
        wrapLines: true,
        wrapLongLines: true,
        customStyle: customStyle,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SyntaxHighlighter);


/***/ }),

/***/ 20090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  text-align: left;\n  font-size: 14px;\n  text-decoration: none;\n  color: var(--color-secondary);\n  margin-bottom: 32px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BackLink = function(_param) {
    var className = _param.className, text = _param.text, to = _param.to, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "text",
        "to"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to
    }, props), {
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(StyledA, {
            className: className,
            children: [
                "← ",
                text
            ]
        })
    }));
};
var StyledA = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-78d9d681-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (BackLink);


/***/ }),

/***/ 20325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80651);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81990);
/* harmony import */ var _SyntaxHighlighter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7967);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96169);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43195);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  padding: 0;\n  max-width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  ul {\n    margin: 0;\n    list-style-type: '- ';\n\n    li {\n      margin-bottom: 8px;\n      font-size: 16px;\n\n      :last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var MarkdownView = function(_param) {
    var children = _param.children, customComponents = _param.customComponents, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "customComponents",
        "className"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledMarkdown, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className,
        children: children,
        linkTarget: "_blank",
        components: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, {
            h1: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledHeading, {
                    variant: "h1",
                    normalWeight: true,
                    children: children,
                    marginBottomPx: 12
                });
            },
            h2: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledHeading, {
                    variant: "h2",
                    normalWeight: true,
                    children: children,
                    marginBottomPx: 8
                });
            },
            h3: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledHeading, {
                    variant: "h3",
                    normalWeight: true,
                    children: children,
                    marginBottomPx: 4
                });
            },
            p: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: children
                });
            },
            code: function(param) {
                var className = param.className, children = param.children;
                /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_SyntaxHighlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    language: (className === null || className === void 0 ? void 0 : className.split("-")[1]) || "",
                    children: children[0],
                    customStyle: {
                        background: "rgba(0,0,0,0)",
                        border: "none"
                    }
                });
            },
            pre: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Pre, {
                    children: children
                });
            }
        }, customComponents)
    }, props));
};
var Pre = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].pre.withConfig */ .ZP.pre.withConfig({
    componentId: "sc-bbb00dc8-0"
})(_templateObject());
var StyledHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bbb00dc8-1"
})(_templateObject1(), function(props) {
    return props.marginBottomPx && "".concat(props.marginBottomPx, "px");
});
var StyledMarkdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(react_markdown__WEBPACK_IMPORTED_MODULE_9__/* .ReactMarkdown */ .D).withConfig({
    componentId: "sc-bbb00dc8-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["default"] = (MarkdownView);


/***/ }),

/***/ 45420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ video_VideoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./node_modules/@u-wave/react-vimeo/dist/react-vimeo.es.js + 1 modules
var react_vimeo_es = __webpack_require__(32993);
// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
// EXTERNAL MODULE: ./src/components/core/Heading.tsx
var Heading = __webpack_require__(96169);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(262);
// EXTERNAL MODULE: ./node_modules/react-countdown-circle-timer/lib/index.module.js
var index_module = __webpack_require__(69975);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
;// CONCATENATED MODULE: ./src/components/domain/video/NextLectureOverlay.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: black;\n  opacity: 0.9;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  > * {\n    color: white;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var NextLectureOverlay = function(param) {
    var lectureUrl = param.lectureUrl, lectureTitle = param.lectureTitle, onClosed = param.onClosed, hasQuiz = param.hasQuiz;
    var router = (0,next_router.useRouter)();
    var nextLecturePush = function() {
        router.push(lectureUrl);
    };
    if (hasQuiz) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WrapperFlex, {
            justifyContent: "center",
            gap: "12px",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                    variant: "h5",
                    children: "Nezabudni si spraviť kv\xedz"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseText, {
                    size: "very-small",
                    onClick: onClosed,
                    children: "Zavrieť"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WrapperFlex, {
        justifyContent: "center",
        gap: "12px",
        direction: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                size: "small",
                children: "Ďalšia lekcia"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                variant: "h5",
                children: lectureTitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountdownWrapper, {
                onClick: nextLecturePush,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_module/* CountdownCircleTimer */.$, {
                    isPlaying: true,
                    duration: 3,
                    colors: "#FFFFFF",
                    size: 72,
                    onComplete: nextLecturePush,
                    strokeWidth: 5,
                    children: function() {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* BsPlayFill */.W9m, {
                            size: 24
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseText, {
                size: "very-small",
                onClick: onClosed,
                children: "Zavrieť"
            })
        ]
    });
};
// we don't want this to change colors based on current theme
var WrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c75ee320-0"
})(_templateObject());
var CountdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c75ee320-1"
})(_templateObject1());
var CloseText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c75ee320-2"
})(_templateObject2());
/* harmony default export */ var video_NextLectureOverlay = (NextLectureOverlay);

// EXTERNAL MODULE: ./src/localStorage.ts + 1 modules
var localStorage = __webpack_require__(95440);
;// CONCATENATED MODULE: ./src/components/domain/video/VideoWrapper.tsx

function VideoWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 100%;\n  height: 0;\n  padding-bottom: 56.25%;\n  position: relative;\n\n  iframe {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    VideoWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var VideoWrapper = function(param) {
    var className = param.className, autoplay = param.autoplay, vimeoVideoId = param.vimeoVideoId, onVideoEnded = param.onVideoEnded, nextLectureUrl = param.nextLectureUrl, nextLectureName = param.nextLectureName, hasQuiz = param.hasQuiz;
    var ref = (0,react.useState)(false), showNextLectureOverlay = ref[0], setShowNextLectureOverlay = ref[1];
    var ref1 = (0,react.useState)(1), vimeoPlaybackRate = ref1[0], setVimeoPlaybackRate = ref1[1];
    (0,react.useEffect)(function() {
        var vimeoPlaybackRate = localStorage/* storage.getVimeoPlaybackRate */.t.getVimeoPlaybackRate();
        if (vimeoPlaybackRate != null) {
            setVimeoPlaybackRate(parseFloat(vimeoPlaybackRate));
        }
    }, []);
    var handleOnVideoEnded = function() {
        if (onVideoEnded) {
            if (document.fullscreenElement) {
                // next lecture overlay is not visible in full-screen mode
                // so we exit full-screen so user can see overlay
                document.exitFullscreen();
            }
            onVideoEnded();
        }
        localStorage/* storage.deleteVideoWatchTime */.t.deleteVideoWatchTime(vimeoVideoId);
        if (nextLectureUrl && nextLectureName) {
            setShowNextLectureOverlay(true);
        }
    };
    var handleVimeoPlaybackRateChanged = function(value) {
        var _vimeoPlaybackRate = value.playbackRate;
        localStorage/* storage.setVimeoPlaybackRate */.t.setVimeoPlaybackRate(_vimeoPlaybackRate.toString());
        setVimeoPlaybackRate(_vimeoPlaybackRate);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledVideoWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_vimeo_es/* default */.Z, {
                speed: true,
                keyboard: true,
                video: vimeoVideoId,
                autoplay: autoplay,
                onEnd: handleOnVideoEnded,
                start: localStorage/* storage.getVideoWatchTime */.t.getVideoWatchTime(vimeoVideoId).seconds,
                onTimeUpdate: function(event) {
                    var videoSecondsWatched = localStorage/* storage.getVideoWatchTime */.t.getVideoWatchTime(vimeoVideoId).seconds;
                    var secondsWatched = Math.floor(event.seconds);
                    var updateIntervalSeconds = 5;
                    if (secondsWatched - videoSecondsWatched > updateIntervalSeconds) {
                        localStorage/* storage.setVideoWatchTime */.t.setVideoWatchTime(vimeoVideoId, {
                            seconds: secondsWatched
                        });
                    }
                },
                playbackRate: vimeoPlaybackRate,
                onPlaybackRateChange: handleVimeoPlaybackRateChanged
            }),
            showNextLectureOverlay && nextLectureUrl && nextLectureName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(video_NextLectureOverlay, {
                lectureTitle: nextLectureName,
                lectureUrl: nextLectureUrl,
                onClosed: function() {
                    return setShowNextLectureOverlay(false);
                },
                hasQuiz: hasQuiz || false
            })
        ]
    });
};
var StyledVideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5092cdce-0"
})(VideoWrapper_templateObject());
/* harmony default export */ var video_VideoWrapper = (VideoWrapper);


/***/ }),

/***/ 52642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./src/components/core/Heading.tsx
var Heading = __webpack_require__(96169);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
// EXTERNAL MODULE: ./src/components/core/BackLink.tsx
var BackLink = __webpack_require__(20090);
// EXTERNAL MODULE: ./src/utils.tsx
var utils = __webpack_require__(10447);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(72444);
// EXTERNAL MODULE: ./src/theme/icons/DifficultyIcon.tsx
var DifficultyIcon = __webpack_require__(96428);
// EXTERNAL MODULE: ./src/components/core/Rating.tsx
var Rating = __webpack_require__(97266);
// EXTERNAL MODULE: ./src/components/core/Avatar.tsx
var Avatar = __webpack_require__(72463);
// EXTERNAL MODULE: ./src/components/CircullarProgressWithLabel.tsx
var CircullarProgressWithLabel = __webpack_require__(90655);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(25925);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-accordion/dist/index.module.js + 1 modules
var index_module = __webpack_require__(21648);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(52617);
// EXTERNAL MODULE: ./src/theme/device.ts
var device = __webpack_require__(40592);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(80371);
// EXTERNAL MODULE: ./src/AuthUserContext.tsx
var AuthUserContext = __webpack_require__(92232);
// EXTERNAL MODULE: ./src/QueryGuard.tsx
var QueryGuard = __webpack_require__(10229);
// EXTERNAL MODULE: ./src/api/lecture.ts
var api_lecture = __webpack_require__(31258);
// EXTERNAL MODULE: ./src/components/core/MarkdownView.tsx
var MarkdownView = __webpack_require__(20325);
// EXTERNAL MODULE: ./src/components/core/Modal.tsx + 1 modules
var Modal = __webpack_require__(5395);
// EXTERNAL MODULE: ./src/components/domain/video/VideoWrapper.tsx + 1 modules
var VideoWrapper = __webpack_require__(45420);
;// CONCATENATED MODULE: ./src/components/domain/lecture/LecturePreview.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1024px;\n  width: calc(100% - 80px);\n  padding: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var LecturePreview = function(param) {
    var lecture = param.lecture, onClosePreview = param.onClosePreview;
    var getLectureQuery = (0,api_lecture/* useGetLecture */.K)(lecture.id, true);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModal, {
        onClose: onClosePreview,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryGuard/* QueryGuard */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getLectureQuery), {
            children: function(lecture) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        lecture.videoUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoWrapper/* default */.Z, {
                            vimeoVideoId: lecture.videoUrl,
                            autoplay: true
                        }),
                        lecture.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarkdownView["default"], {
                            children: lecture.content
                        })
                    ]
                });
            }
        }))
    });
};
var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-556d75a8-0"
})(_templateObject());
/* harmony default export */ var lecture_LecturePreview = (LecturePreview);

;// CONCATENATED MODULE: ./src/components/domain/course/CourseContent.tsx




function CourseContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CourseContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0 4px 4px 4px;\n  border-bottom: 2px solid var(--color-accent);\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: unset;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 550px;\n  gap: 8px;\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  padding: 2px 4px;\n  border-radius: 4px;\n  background-color: var(--color-accent);\n  color: var(--color-primary);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  [data-state='open'] & {\n    animation: ",
        " 300ms ease-out forwards;\n    overflow: hidden;\n  }\n  [data-state='closed'] & {\n    animation: ",
        " 300ms ease-out forwards;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 4px;\n\n  &:hover {\n    cursor: ",
        ";\n    color: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    color: var(--color-secondary);\n  }\n\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--color-shadow);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 300ms;\n  [data-state='open'] & {\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  flex-shrink: 0;\n  color: var(--color-secondary);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}














var CourseContent = function(_param) {
    var className = _param.className, course = _param.course, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "course"
    ]);
    var router = (0,next_router.useRouter)();
    var user = (0,AuthUserContext/* useAuth */.a)().user;
    var ref = (0,react.useState)(null), previewLectureInModal = ref[0], setPreviewLectureInModal = ref[1];
    var states = utils/* getCourseProductStates */.D0(course, user);
    var isLectureClickable = function(lecture) {
        if (states.hasNoActiveProductsAndIsLoggedIn || states.hasActiveProductsAndIsOwnedByUser) return true;
        var allowPreviewWhenPaid = lecture.allowPreviewWhenPaid;
        if (allowPreviewWhenPaid && states.hasActiveProductsButIsNotOwnedByUser) return true;
        return false;
    };
    var shouldPreviewLectureForPaidCourse = function(lecture) {
        return isLectureClickable(lecture) && states.hasActiveProductsButIsNotOwnedByUser;
    };
    var getChapterLengthInfo = function(chapter) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
            align: "right",
            children: [
                chapter.lectures.length,
                " ",
                utils/* numOfLecturesText */.Wg(chapter.lectures.length),
                " | ",
                chapter.chapterDurationMinutes,
                " ",
                utils/* numOfMinutesText */.m0(chapter.chapterDurationMinutes)
            ]
        });
    };
    var handleLectureOnClick = function(e, chapterId, lectureId, lecture) {
        e.preventDefault();
        e.stopPropagation();
        if (shouldPreviewLectureForPaidCourse(lecture)) {
            setPreviewLectureInModal(lecture);
        } else if (isLectureClickable(lecture)) {
            router.push(routes/* routes.kurzy.lekcia */._.kurzy.lekcia(course.slug, chapterId, lectureId));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: className
            }, props), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionRoot, {
                    type: "multiple",
                    defaultValue: [
                        course.chapters[0].id.toString()
                    ],
                    children: course.chapters.map(function(chapter) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                            value: chapter.id.toString(),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Trigger, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                                variant: "h5",
                                                normalWeight: true,
                                                children: chapter.name
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                gap: "24px",
                                                children: [
                                                    getChapterLengthInfo(chapter),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionChevron, {})
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
                                    children: chapter.lectures.map(function(lecture) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionContentWrapper, {
                                            onClick: function(e) {
                                                return handleLectureOnClick(e, chapter.id, lecture.id, lecture);
                                            },
                                            clickable: isLectureClickable(lecture),
                                            justifyContent: "space-between",
                                            gap: "4px",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                    gap: "12px",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LectureTypeIcon, {
                                                            children: utils/* getLectureTypeIcon */.vW(lecture.lectureType)
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, {
                                                            children: lecture.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                    gap: "8px",
                                                    children: [
                                                        lecture.videoDurationSeconds > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, {
                                                            size: "small",
                                                            children: utils/* formatDurationFromSeconds */.Ae(lecture.videoDurationSeconds)
                                                        }),
                                                        shouldPreviewLectureForPaidCourse(lecture) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreviewText, {
                                                            size: "very-small",
                                                            children: "n\xe1hľad"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, lecture.id);
                                    })
                                })
                            ]
                        }, chapter.id);
                    })
                })
            })),
            previewLectureInModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lecture_LecturePreview, {
                lecture: previewLectureInModal,
                onClosePreview: function() {
                    return setPreviewLectureInModal(null);
                }
            })
        ]
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2cd60661-0"
})(CourseContent_templateObject());
var AccordionRoot = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Root */.fC).withConfig({
    componentId: "sc-2cd60661-1"
})(_templateObject1());
var Header = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Header */.h4).withConfig({
    componentId: "sc-2cd60661-2"
})(_templateObject2());
var Trigger = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Trigger */.xz).withConfig({
    componentId: "sc-2cd60661-3"
})(_templateObject3(), device/* device.L */.U.L);
var Item = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Item */.ck).withConfig({
    componentId: "sc-2cd60661-4"
})(_templateObject4());
var LectureTypeIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2cd60661-5"
})(_templateObject5());
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-2cd60661-6"
})(_templateObject6());
var PreviewText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-2cd60661-7"
})(_templateObject7());
var openContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-accordion-content-height)"
    }
});
var closeContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)({
    from: {
        height: "var(--radix-accordion-content-height)"
    },
    to: {
        height: 0
    }
});
var AccordionContent = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Content */.VY).withConfig({
    componentId: "sc-2cd60661-8"
})(_templateObject8(), openContentAnimation, closeContentAnimation);
var AccordionContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2cd60661-9"
})(_templateObject9(), function(props) {
    return props.clickable && "pointer";
}, function(props) {
    return props.clickable && "var(--color-accent)";
}, StyledText, function(props) {
    return props.clickable && "var(--color-accent)";
});
var AccordionChevron = (0,styled_components_browser_esm/* default */.ZP)(bi_index_esm/* BiChevronDown */.OrA).withConfig({
    componentId: "sc-2cd60661-10"
})(_templateObject10());
/* harmony default export */ var course_CourseContent = (CourseContent);

// EXTERNAL MODULE: ./src/components/PageContentWrapper.tsx
var PageContentWrapper = __webpack_require__(41246);
// EXTERNAL MODULE: ./src/components/NavBar.tsx + 1 modules
var NavBar = __webpack_require__(55270);
// EXTERNAL MODULE: ./src/api/courseOverview.ts
var api_courseOverview = __webpack_require__(74268);
// EXTERNAL MODULE: ./src/api/courseReviewOverviews.ts
var courseReviewOverviews = __webpack_require__(41777);
// EXTERNAL MODULE: ./src/api/courseReviews.ts
var courseReviews = __webpack_require__(78693);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./src/components/domain/course-review/EditableCourseReview.tsx
var EditableCourseReview = __webpack_require__(79228);
;// CONCATENATED MODULE: ./src/components/domain/course-review/AddCourseReview.tsx






var AddCourseReview = function(param) {
    var courseId = param.courseId, courseSlug = param.courseSlug;
    var addCourseReviewMutation = (0,courseReviews/* useAddCourseReview */.mw)(courseId, courseSlug);
    var addCourseReview = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(rating, text) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            addCourseReviewMutation.mutateAsync({
                                courseId: courseId,
                                rating: rating,
                                text: text
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function addCourseReview(rating, text) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditableCourseReview/* default */.Z, {
        onSubmit: addCourseReview
    });
};
/* harmony default export */ var course_review_AddCourseReview = (AddCourseReview);

// EXTERNAL MODULE: ./src/components/domain/course-review/CourseReviewItem.tsx + 1 modules
var CourseReviewItem = __webpack_require__(10401);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(9507);
;// CONCATENATED MODULE: ./src/components/domain/course-review/CourseReviews.tsx



function CourseReviews_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 500px;\n  width: 100%;\n"
    ]);
    CourseReviews_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var CourseReviews = function(param) {
    var className = param.className, courseOverview = param.courseOverview, innerRef = param.innerRef;
    var ref = (0,AuthUserContext/* useAuth */.a)(), userId = ref.userId, isLoading = ref.isLoading;
    var courseId = courseOverview.id;
    var courseSlug = courseOverview.slug;
    var getCourseReviewsQuery = (0,courseReviews/* useGetCourseReviews */.KM)(courseId);
    var getCourseReviewsOverviewQuery = (0,courseReviewOverviews/* useGetCourseReviewsOverview */.M)(courseId);
    var hasUserReview = getCourseReviewsQuery.data && getCourseReviewsQuery.data.some(function(courseReview) {
        return courseReview.userId === userId;
    });
    var hasCourseProducts = courseOverview.courseProducts.length !== 0;
    var usersOwnsTheCourse = (0,utils/* isCourseOwnedByUser */._k)(courseOverview);
    var canAddReview = userId && !hasUserReview && (!hasCourseProducts || hasCourseProducts && usersOwnsTheCourse);
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WrapperFlex, {
        className: className,
        innerRef: innerRef,
        direction: "column",
        gap: "32px",
        alignSelf: "flex-start",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryGuard/* QueryGuard */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getCourseReviewsOverviewQuery), {
                children: function(courseReviewsOverview) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                        alignSelf: "center",
                        gap: "32px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                variant: "h4",
                                normalWeight: true,
                                align: "center",
                                children: "Hodnotenia"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                                gap: "8px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating/* default */.Z, {
                                    readOnly: true,
                                    value: courseReviewsOverview.averageRating,
                                    customSize: "32px"
                                })
                            })
                        ]
                    });
                }
            })),
            canAddReview && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(course_review_AddCourseReview, {
                courseId: courseId,
                courseSlug: courseSlug
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryGuard/* QueryGuard */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getCourseReviewsQuery), {
                children: function(courseReviews) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                        direction: "column",
                        gap: "16px",
                        alignSelf: "stretch",
                        children: courseReviews.map(function(courseReview) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseReviewItem/* default */.Z, {
                                review: courseReview,
                                courseSlug: courseSlug,
                                allowUpdating: true
                            }, courseReview.id);
                        })
                    });
                }
            }))
        ]
    });
};
var WrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d189a31e-0"
})(CourseReviews_templateObject());
/* harmony default export */ var course_review_CourseReviews = (CourseReviews);

// EXTERNAL MODULE: ./src/components/core/NextLink.tsx
var NextLink = __webpack_require__(96791);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(51774);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Head.tsx
var Head = __webpack_require__(26221);
;// CONCATENATED MODULE: ./src/components/domain/course-review/SidebarCourseReviews.tsx



function SidebarCourseReviews_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 500px;\n  width: 100%;\n"
    ]);
    SidebarCourseReviews_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var SidebarCourseReviews = function(param) {
    var className = param.className, courseOverview = param.courseOverview;
    var isLoading = (0,AuthUserContext/* useAuth */.a)().isLoading;
    var courseId = courseOverview.id;
    var courseSlug = courseOverview.slug;
    var getCourseReviewsQuery = (0,courseReviews/* useGetCourseReviews */.KM)(courseId);
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SidebarCourseReviews_WrapperFlex, {
        className: className,
        direction: "column",
        gap: "32px",
        alignSelf: "flex-start",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryGuard/* QueryGuard */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getCourseReviewsQuery), {
            children: function(courseReviews) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                    direction: "column",
                    gap: "16px",
                    alignSelf: "stretch",
                    children: courseReviews.sort(function(a, b) {
                        return b.rating - a.rating;
                    }).slice(0, 2).map(function(courseReview) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseReviewItem/* default */.Z, {
                            review: courseReview,
                            courseSlug: courseSlug
                        }, courseReview.id);
                    })
                });
            }
        }))
    });
};
var SidebarCourseReviews_WrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-befba588-0"
})(SidebarCourseReviews_templateObject());
/* harmony default export */ var course_review_SidebarCourseReviews = (SidebarCourseReviews);

// EXTERNAL MODULE: ./src/components/core/Button.tsx
var Button = __webpack_require__(21523);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(39321);
// EXTERNAL MODULE: ./src/images.tsx + 15 modules
var src_images = __webpack_require__(21442);
;// CONCATENATED MODULE: ./src/components/domain/course/CourseProducts.tsx

function CourseProducts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 75%;\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    CourseProducts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    CourseProducts_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding-bottom: 24px;\n  border-bottom: 2px solid var(--color-accent);\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    CourseProducts_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: unset;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
    ]);
    CourseProducts_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  [data-state='open'] & {\n    animation: ",
        " 300ms ease-out forwards;\n    overflow: hidden;\n  }\n  [data-state='closed'] & {\n    animation: ",
        " 300ms ease-out forwards;\n    overflow: hidden;\n  }\n"
    ]);
    CourseProducts_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CourseProducts_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 4px;\n\n  &:hover {\n    cursor: ",
        ";\n    color: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    color: var(--color-secondary);\n  }\n"
    ]);
    CourseProducts_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  transition: transform 300ms;\n  [data-state='open'] & {\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  flex-shrink: 0;\n  color: var(--color-secondary);\n"
    ]);
    CourseProducts_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    flex-direction: column;\n    gap: 36px;\n  }\n"
    ]);
    CourseProducts_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 48px;\n  padding: 16px 16px 24px 16px;\n  border-radius: 22px;\n  border: 6px solid var(--color-accent);\n  width: 500px;\n\n  @media ",
        " {\n    width: 360px;\n  }\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    CourseProducts_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CourseProducts_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: stretch;\n  padding-top: 64px;\n  padding-bottom: 24px;\n  border-radius: 18px;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  border: 4px solid var(--color-accent);\n  position: relative;\n"
    ]);
    CourseProducts_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  aspect-ratio: 1;\n  border-radius: 10px;\n  border: 4px solid var(--color-accent);\n  background-color: var(--color-primary);\n\n  position: absolute;\n  bottom: 85%;\n  left: 50%;\n  transform: translateX(-50%);\n\n  span {\n    margin: 12px !important;\n  }\n\n  @media ",
        " {\n    width: 80px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  align-self: stretch;\n  margin: 0;\n  padding-top: 0;\n  padding-right: 8px;\n  padding-left: 8px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid var(--color-accent);\n\n  li {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n\n    :before {\n      content: '✓';\n    }\n\n    :not(:last-of-type) {\n      margin-bottom: 12px;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 260px;\n  background-color: var(--color-accent);\n  border-color: var(--color-accent);\n\n  @media ",
        " {\n    width: 220px;\n  }\n\n  @media ",
        " {\n    width: 200px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 8px;\n  padding-left: 8px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
















var JavaKurzCourseProduct = function(param) {
    var className = param.className, course = param.course, innerRef = param.innerRef;
    var isCourseOwnedByUser = utils/* isCourseOwnedByUser */._k(course);
    if (isCourseOwnedByUser) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var activeCourseProducts = course.courseProducts.filter(function(c) {
        return !c.archived;
    });
    utils/* assert */.hu(activeCourseProducts.length === 1, "Expected 1 active course product");
    var javaProduct = activeCourseProducts[0];
    var counter = 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        direction: "column",
        gap: "48px",
        alignItems: "center",
        className: className,
        innerRef: innerRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsFlex, {
                justifyContent: "center",
                gap: "32px",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
                    direction: "column",
                    gap: "16px",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderWrapper, {
                            direction: "column",
                            gap: "16px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h5",
                                    align: "center",
                                    children: "Chcem sa stať Java program\xe1torom/kou"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h4",
                                    children: javaProduct.price != null ? "".concat(javaProduct.price / 100, " €") : "N/A"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                    href: {
                                        pathname: routes/* routes.checkout.courseProduct */._.checkout.courseProduct(course.slug, javaProduct.productId)
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                        variant: "accent",
                                        disabled: javaProduct.price == null,
                                        uppercase: true,
                                        children: "K\xfapiť"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseImageWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "Java kurz",
                                        src: src_images/* javaCourseLogo */.KM,
                                        layout: "fill",
                                        priority: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BenefitsSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Pr\xedstup ku všetk\xfdm vide\xe1m navždy"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Všetky \xfalohy a zadania"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Všetky zadania ohodnoten\xe9 lektorom"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Pr\xedstup k s\xfakromnej Discord komunite"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Kari\xe9rne poradenstvo"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomText, {
                            children: "Staň sa Junior Java program\xe1torom/kou! V kurze sa nauč\xedš všetko potrebn\xe9 a dostaneš podporu našej Discord komunity. Nekupuj 4 r\xf4zne kurzy od r\xf4znych inštruktorov, stač\xed ti tento jeden."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                variant: "h4",
                children: "Čast\xe9 ot\xe1zky"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_AccordionRoot, {
                type: "multiple",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Pre koho je kurz určen\xfd?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                        children: [
                                            "Tento kurz nie je pre \xfapln\xfdch začiatočn\xedkov. Javu s\xedce nemus\xedš poznať v\xf4bec, ale mať za sebou už aspoň trošku programovania \xe1no. Ak m\xe1š z\xe1ujem sk\xf4r o kurz, ktor\xfd ťa uvedie do sveta programovania, tak na to m\xe1me zadarmo kurz",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: "/kurzy/informatika-101",
                                                target: "_blank",
                                                children: "Informatika 101"
                                            }),
                                            ". Z\xe1roveň tento Java kurz je pre všetk\xfdch seri\xf3znych z\xe1ujemcov stať sa Java program\xe1torom či program\xe1torkou."
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Čo všetko z\xedskam?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                        children: [
                                            "Po zak\xfapen\xed kurzu z\xedskaš pr\xedstup ku všetk\xfdm vide\xe1m, \xfaloh\xe1m, zadaniam, materi\xe1lom či s\xfakromnej Discord komunite. Študenti tohto kurzu si najviac cenia hodnotenie zadan\xed.",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            "Kurz sa sklad\xe1 z dopredu nahrat\xfdch vide\xed a \xfaloh. Každ\xfd študent si ide vlastn\xfdm tempom a pozer\xe1 vide\xe1 kedy chce, v akom porad\xed chce."
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseValidationQuestion, {
                        counter: counter++
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentMethodsQuestion, {
                        counter: counter++
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Čo ak m\xe1m z\xe1ujem o osobn\xe9 konzult\xe1cie?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                        children: [
                                            "Po zak\xfapen\xed kurzu z\xedskaš pr\xedstup ku s\xfakromnej Discord komunite, kde m\xf4žeš kl\xe1sť ot\xe1zky. Navyše s každ\xfdm študentom sa snaž\xedm mať osobn\xfd kontakt (na Discorde) a pom\xf4cť mu s jeho probl\xe9mami.",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            "Ak m\xe1š z\xe1ujem o osobn\xe9 konzult\xe1cie, nap\xedš mi na jakub@streetofcode.sk (alebo na Discorde) a dohodneme sa. Cez osobn\xe9 konzul\xe1cie formou videohovoru vieme spolu napr\xedklad riešiť nasledovn\xe9 t\xe9my:",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                        children: "Pr\xedprava na pohovor (vieme si dať aj simulovan\xfd pohovor)"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                        children: "Code review"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                        children: "Technick\xe9 a in\xe9 ot\xe1zky"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                        children: "Tvorba životopisu a kari\xe9rne poradenstvo"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Dostanem certifik\xe1t?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Veľmi r\xe1d by som nap\xedsal, že bude pekn\xfd farebn\xfd certifik\xe1t, no pravda je tak\xe1, že certifik\xe1ty z programovania skoro nikoho nezauj\xedmaj\xfa. Na pohovore sa ťa bud\xfa p\xfdtať technick\xe9 ot\xe1zky a pozerať na tvoje projekty na GitHube, a nie na to, či m\xe1š certifik\xe1t o absolvovan\xed kurzu. Na veciach, na ktor\xfdch z\xe1lež\xed, ťa v tomto kurze priprav\xedm."
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var SQLCourseProduct = function(param) {
    var className = param.className, course = param.course, innerRef = param.innerRef;
    var isCourseOwnedByUser = utils/* isCourseOwnedByUser */._k(course);
    if (isCourseOwnedByUser) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var activeCourseProducts = course.courseProducts.filter(function(c) {
        return !c.archived;
    });
    utils/* assert */.hu(activeCourseProducts.length === 1, "Expected 1 active course product");
    var sqlProduct = activeCourseProducts[0];
    var counter = 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        direction: "column",
        gap: "48px",
        alignItems: "center",
        className: className,
        innerRef: innerRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsFlex, {
                justifyContent: "center",
                gap: "32px",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
                    direction: "column",
                    gap: "16px",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderWrapper, {
                            direction: "column",
                            gap: "16px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h5",
                                    align: "center",
                                    children: "Chcem sa naučiť z\xe1klady SQL"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h4",
                                    children: sqlProduct.price != null ? "".concat(sqlProduct.price / 100, " €") : "N/A"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                    href: {
                                        pathname: routes/* routes.checkout.courseProduct */._.checkout.courseProduct(course.slug, sqlProduct.productId)
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                        variant: "accent",
                                        disabled: sqlProduct.price == null,
                                        uppercase: true,
                                        children: "K\xfapiť"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseImageWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "SQL Z\xe1klady kurz",
                                        src: src_images/* sqlLogoImage */.Uj,
                                        layout: "fill",
                                        priority: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomText, {
                            children: "Ovl\xe1dni z\xe1klady SQL. Nauč sa prehľad\xe1vať a vytv\xe1rať d\xe1ta, ako aj navrhovať vlastn\xe9 datab\xe1zy."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                variant: "h4",
                children: "Čast\xe9 ot\xe1zky"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_AccordionRoot, {
                type: "multiple",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Pre koho je kurz určen\xfd?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Kurz je určen\xfd pre všetk\xfdch, ktor\xed sa chc\xfa naučiť z\xe1klady SQL. Nie je potrebn\xe1 žiadna predch\xe1dzaj\xfaca znalosť datab\xe1z. Či už si zač\xednaj\xfaci program\xe1tor, analytik, alebo manaž\xe9r, tento kurz ti pom\xf4že zlepšiť tvoje schopnosti pr\xe1ce s d\xe1tami."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Čo všetko z\xedskam?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Po zak\xfapen\xed kurzu z\xedskaš pr\xedstup ku všetk\xfdm vide\xe1m, \xfaloh\xe1m a materi\xe1lom. Každ\xfd študent si ide vlastn\xfdm tempom a pozer\xe1 vide\xe1 kedy chce, v akom porad\xed chce."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseValidationQuestion, {
                        counter: counter++
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentMethodsQuestion, {
                        counter: counter++
                    })
                ]
            })
        ]
    });
};
var AICourseProduct = function(param) {
    var className = param.className, course = param.course, innerRef = param.innerRef;
    var isCourseOwnedByUser = utils/* isCourseOwnedByUser */._k(course);
    if (isCourseOwnedByUser) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var activeCourseProducts = course.courseProducts.filter(function(c) {
        return !c.archived;
    });
    utils/* assert */.hu(activeCourseProducts.length === 1, "Expected 1 active course product");
    var aiProduct = activeCourseProducts[0];
    var counter = 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        direction: "column",
        gap: "48px",
        alignItems: "center",
        className: className,
        innerRef: innerRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsFlex, {
                justifyContent: "center",
                gap: "32px",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
                    direction: "column",
                    gap: "16px",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderWrapper, {
                            direction: "column",
                            gap: "16px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h5",
                                    align: "center",
                                    children: "Chcem sa naučiť ovl\xe1dať AI n\xe1stroje"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h4",
                                    children: aiProduct.price != null ? "".concat(aiProduct.price / 100, " €") : "N/A"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                    href: {
                                        pathname: routes/* routes.checkout.courseProduct */._.checkout.courseProduct(course.slug, aiProduct.productId)
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                        variant: "accent",
                                        disabled: aiProduct.price == null,
                                        uppercase: true,
                                        children: "K\xfapiť"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseImageWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "AI kurz",
                                        src: src_images/* aiLogoImage */.ic,
                                        layout: "fill",
                                        priority: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomText, {
                            children: "Updatni svoj sp\xf4sob programovania s AI n\xe1strojmi - od GitHub Copilot až po Claude Code"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                variant: "h4",
                children: "Čast\xe9 ot\xe1zky"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_AccordionRoot, {
                type: "multiple",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Pre koho je kurz určen\xfd?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Tento kurz je pre program\xe1torov, ktor\xed už maj\xfa z\xe1kladn\xe9 programovacie sk\xfasenosti. Nemus\xedš byť senior, ale mal/a by si vedieť pracovať vo svojom IDE (VSCode, Visual Studio, IntelliJ IDEA alebo podobn\xe9), rozumieť z\xe1kladom Git a GitHub a orientovať sa v k\xf3de svojho hlavn\xe9ho programovacieho jazyka."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Čo všetko z\xedskam?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Po zak\xfapen\xed kurzu z\xedskaš pr\xedstup ku všetk\xfdm vide\xe1m a materi\xe1lom. Každ\xfd študent si ide vlastn\xfdm tempom a pozer\xe1 vide\xe1 kedy chce, v akom porad\xed chce."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "M\xe1me z\xe1ujem o firemn\xe9 školenie"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Ak m\xe1te z\xe1ujem o firemn\xe9 školenie, kontaktujte n\xe1s na info@streetofcode.sk. Priprav\xedm v\xe1m ponuku do mailu pre školenie vo vašich priestoroch."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseValidationQuestion, {
                        counter: counter++
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentMethodsQuestion, {
                        counter: counter++
                    })
                ]
            })
        ]
    });
};
var WebGamesCourseProduct = function(param) {
    var className = param.className, course = param.course, innerRef = param.innerRef;
    var isCourseOwnedByUser = utils/* isCourseOwnedByUser */._k(course);
    if (isCourseOwnedByUser) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var activeCourseProducts = course.courseProducts.filter(function(c) {
        return !c.archived;
    });
    utils/* assert */.hu(activeCourseProducts.length === 1, "Expected 1 active course product");
    var webGamesProduct = activeCourseProducts[0];
    var counter = 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        direction: "column",
        gap: "48px",
        alignItems: "center",
        className: className,
        innerRef: innerRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsFlex, {
                justifyContent: "center",
                gap: "32px",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
                    direction: "column",
                    gap: "16px",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderWrapper, {
                            direction: "column",
                            gap: "16px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h5",
                                    align: "center",
                                    children: "Chcem sa naučiť k\xf3diť webov\xe9 hry"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h4",
                                    children: webGamesProduct.price != null ? "".concat(webGamesProduct.price / 100, " €") : "N/A"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                    href: {
                                        pathname: routes/* routes.checkout.courseProduct */._.checkout.courseProduct(course.slug, webGamesProduct.productId)
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutButton, {
                                        variant: "accent",
                                        disabled: webGamesProduct.price == null,
                                        uppercase: true,
                                        children: "K\xfapiť"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseImageWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        alt: "Webov\xe9 hry kurz",
                                        src: src_images/* webGamesLogo */.X2,
                                        layout: "fill",
                                        priority: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomText, {
                            children: "Vytvor si 3 klasick\xe9 hry a pridaj si ich do svojho portf\xf3lia."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                variant: "h4",
                children: "Čast\xe9 ot\xe1zky"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_AccordionRoot, {
                type: "multiple",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Pre koho je kurz určen\xfd?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Tento kurz je ide\xe1lny pre začiatočn\xedkov, ktor\xed už poznaj\xfa z\xe1klady HTML, CSS a JavaScriptu a chc\xfa si vytvoriť prv\xe9 interakt\xedvne projekty. Je to perfektn\xe1 pr\xedležitosť ako si precvičiť svoje znalosti na re\xe1lnych hr\xe1ch, ktor\xe9 m\xf4žete pridať do svojho portf\xf3lia."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
                        value: "".concat(counter++),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h6",
                                            children: "Čo všetko z\xedskam?"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                                    clickable: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        children: "Po zak\xfapen\xed kurzu z\xedskaš pr\xedstup ku všetk\xfdm vide\xe1m a materi\xe1lom. Každ\xfd študent si ide vlastn\xfdm tempom a pozer\xe1 vide\xe1 kedy chce, v akom porad\xed chce."
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseValidationQuestion, {
                        counter: counter++
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentMethodsQuestion, {
                        counter: counter++
                    })
                ]
            })
        ]
    });
};
var CourseValidationQuestion = function(param) {
    var counter = param.counter;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
        value: "".concat(counter++),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                            variant: "h6",
                            children: "Ako dlho budem mať pr\xedstup ku kurzu?"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                    clickable: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                        children: "Po zak\xfapen\xed kurzu budeš mať pr\xedstup ku všetk\xfdm materi\xe1lom navždy."
                    })
                })
            })
        ]
    });
};
var PaymentMethodsQuestion = function(param) {
    var counter = param.counter;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Item, {
        value: "".concat(counter++),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_Header, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseProducts_Trigger, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                            variant: "h6",
                            children: "Ako m\xf4žem platiť?"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionChevron, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContent, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProducts_AccordionContentWrapper, {
                    clickable: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                        children: [
                            "Platbu m\xf4žeš vykonať platobnou kartou. Po platbe z\xedskaš pr\xedstup ku kurzu ihneď. Kurz bude sp\xe1rovan\xfd s tvoj\xedm \xfačtom na str\xe1nke. ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                            "Ak m\xe1š z\xe1ujem o in\xfa formu platby, alebo platbu na fakt\xfaru, kontaktuj n\xe1s na info@streetofcode.sk"
                        ]
                    })
                })
            })
        ]
    });
};
var CourseProducts = function(param) {
    var className = param.className, course = param.course, innerRef = param.innerRef;
    if (course.slug === constants/* courseProductsConfig.javaKurz.slug */.RM.javaKurz.slug) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JavaKurzCourseProduct, {
            course: course,
            innerRef: innerRef,
            className: className
        });
    } else if (course.slug === constants/* courseProductsConfig.sql.slug */.RM.sql.slug) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SQLCourseProduct, {
            course: course,
            innerRef: innerRef,
            className: className
        });
    } else if (course.slug === constants/* courseProductsConfig.webGames.slug */.RM.webGames.slug) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WebGamesCourseProduct, {
            course: course,
            innerRef: innerRef,
            className: className
        });
    } else if (course.slug === constants/* courseProductsConfig.ai.slug */.RM.ai.slug) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AICourseProduct, {
            course: course,
            innerRef: innerRef,
            className: className
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    }
};
var CourseProducts_AccordionRoot = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Root */.fC).withConfig({
    componentId: "sc-2304d2c-0"
})(CourseProducts_templateObject(), device/* device.S */.U.S);
var CourseProducts_Item = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Item */.ck).withConfig({
    componentId: "sc-2304d2c-1"
})(CourseProducts_templateObject1());
var CourseProducts_Header = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Header */.h4).withConfig({
    componentId: "sc-2304d2c-2"
})(CourseProducts_templateObject2());
var CourseProducts_Trigger = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Trigger */.xz).withConfig({
    componentId: "sc-2304d2c-3"
})(CourseProducts_templateObject3());
var CourseProducts_openContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-accordion-content-height)"
    }
});
var CourseProducts_closeContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)({
    from: {
        height: "var(--radix-accordion-content-height)"
    },
    to: {
        height: 0
    }
});
var CourseProducts_AccordionContent = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Content */.VY).withConfig({
    componentId: "sc-2304d2c-4"
})(CourseProducts_templateObject4(), CourseProducts_openContentAnimation, CourseProducts_closeContentAnimation);
var CourseProducts_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-2304d2c-5"
})(CourseProducts_templateObject5());
var CourseProducts_AccordionContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2304d2c-6"
})(CourseProducts_templateObject6(), function(props) {
    return props.clickable && "pointer";
}, function(props) {
    return props.clickable && "var(--color-accent)";
}, CourseProducts_StyledText, function(props) {
    return props.clickable && "var(--color-accent)";
});
var CourseProducts_AccordionChevron = (0,styled_components_browser_esm/* default */.ZP)(bi_index_esm/* BiChevronDown */.OrA).withConfig({
    componentId: "sc-2304d2c-7"
})(CourseProducts_templateObject7());
var CardsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2304d2c-8"
})(CourseProducts_templateObject8(), device/* device.M */.U.M);
var CardWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2304d2c-9"
})(CourseProducts_templateObject9(), device/* device.S */.U.S, device/* device.XS */.U.XS);
var HeaderWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2304d2c-10"
})(CourseProducts_templateObject10());
var CourseImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2304d2c-11"
})(_templateObject11(), device/* device.S */.U.S);
var BenefitsSection = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-2304d2c-12"
})(_templateObject12());
var CheckoutButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-2304d2c-13"
})(_templateObject13(), device/* device.S */.U.S, device/* device.XS */.U.XS);
var BottomText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-2304d2c-14"
})(_templateObject14());
/* harmony default export */ var course_CourseProducts = (CourseProducts);

;// CONCATENATED MODULE: ./src/components/domain/course/CourseCTAButton.tsx

function CourseCTAButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    CourseCTAButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var CourseCTAButton = function(param) {
    var user = param.user, isLoading = param.isLoading, continueUrl = param.continueUrl, courseOverview = param.courseOverview;
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {});
    var states = utils/* getCourseProductStates */.D0(courseOverview, user);
    if (states.hasActiveProductsAndIsOwnedByUser) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: {
                pathname: continueUrl,
                query: {
                    autoplay: "false"
                }
            },
            alignSelf: "stretch",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                variant: "accent",
                disableHoverTransform: true,
                children: courseOverview.userProgressMetadata ? "Pokračovať v kurze" : "Spustiť kurz"
            })
        });
    } else if (states.hasActiveProductsButIsNotOwnedByUser) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "#products",
            style: {
                alignSelf: "stretch"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                variant: "accent",
                disableHoverTransform: true,
                children: "K\xfapiť kurz"
            })
        });
    } else if (states.hasNoActiveProductsAndIsLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: {
                pathname: continueUrl,
                query: {
                    autoplay: "false"
                }
            },
            alignSelf: "stretch",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                variant: "accent",
                disableHoverTransform: true,
                children: courseOverview.userProgressMetadata ? "Pokračovať v kurze" : "Spustiť kurz"
            })
        });
    } else if (states.hasNoActiveProductsAndIsNotLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: routes/* routes.login.redirectUri */._.login.redirectUri(encodeURIComponent(location.pathname)),
            alignSelf: "stretch",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                variant: "accent",
                children: "Pre spustenie kurzu sa najprv prihl\xe1s"
            })
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
            children: "Niekde nastala chyba"
        });
    }
};
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-afe937bb-0"
})(CourseCTAButton_templateObject());
/* harmony default export */ var course_CourseCTAButton = (CourseCTAButton);

// EXTERNAL MODULE: ./src/components/domain/course/CourseCard.tsx
var CourseCard = __webpack_require__(72566);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
;// CONCATENATED MODULE: ./src/components/misc/ai-page/AnimatedCodeEditor.tsx


function AnimatedCodeEditor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n"
    ]);
    AnimatedCodeEditor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n"
    ]);
    AnimatedCodeEditor_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: ",
        " 6s ease-in-out infinite;\n\n  @media ",
        " {\n    animation: none;\n  }\n"
    ]);
    AnimatedCodeEditor_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: var(--color-primary);\n  border: 1px solid var(--color-shadow);\n  border-bottom: none;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    AnimatedCodeEditor_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n"
    ]);
    AnimatedCodeEditor_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: ",
        ";\n"
    ]);
    AnimatedCodeEditor_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-grey);\n  font-size: 12px;\n  margin-left: 16px;\n"
    ]);
    AnimatedCodeEditor_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(var(--color-primary-rgb, 255, 255, 255), 0.5);\n  background: var(--color-primary);\n  border: 1px solid var(--color-shadow);\n  border-top: none;\n  padding: 24px;\n  font-family: 'Fira Code', 'Consolas', monospace;\n  font-size: 14px;\n  min-height: 140px;\n\n  @media ",
        " {\n    padding: 16px;\n    font-size: 12px;\n  }\n"
    ]);
    AnimatedCodeEditor_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  min-height: 24px;\n  line-height: 24px;\n"
    ]);
    AnimatedCodeEditor_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-grey);\n  user-select: none;\n  width: 24px;\n  text-align: right;\n"
    ]);
    AnimatedCodeEditor_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    AnimatedCodeEditor_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-grey);\n  font-style: italic;\n"
    ]);
    AnimatedCodeEditor_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #4f8fef;\n"
    ]);
    AnimatedCodeEditor_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-accent);\n"
    ]);
    AnimatedCodeEditor_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function AnimatedCodeEditor_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-secondary);\n"
    ]);
    AnimatedCodeEditor_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #4f8fef;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-grey);\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 2px;\n  height: 18px;\n  background: var(--color-accent);\n  margin-left: 2px;\n  vertical-align: middle;\n  animation: ",
        " 1s infinite;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(126, 80, 230, 0.1) 0%,\n    transparent 50%,\n    rgba(0, 184, 212, 0.1) 100%\n  );\n  pointer-events: none;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}




var codeLines = [
    "// vytvor funkciu na scitanie",
    "function sum(a: number, b: number) {",
    "  return a + b;",
    "}", 
];
var AnimatedCodeEditor = function() {
    var ref = (0,react.useState)([
        codeLines[0],
        "",
        "",
        "", 
    ]), displayedLines = ref[0], setDisplayedLines = ref[1];
    var ref1 = (0,react.useState)(1), currentLine = ref1[0], setCurrentLine = ref1[1];
    var ref2 = (0,react.useState)(0), currentChar = ref2[0], setCurrentChar = ref2[1];
    (0,react.useEffect)(function() {
        if (currentLine >= codeLines.length) {
            // Reset after completion
            var timer = setTimeout(function() {
                setDisplayedLines([
                    codeLines[0],
                    "",
                    "",
                    ""
                ]);
                setCurrentLine(1);
                setCurrentChar(0);
            }, 3000);
            return function() {
                return clearTimeout(timer);
            };
        }
        var targetLine = codeLines[currentLine];
        if (currentChar <= targetLine.length) {
            var timer1 = setTimeout(function() {
                var newLines = (0,_to_consumable_array/* default */.Z)(codeLines);
                newLines[currentLine] = targetLine.substring(0, currentChar);
                setDisplayedLines(newLines);
                setCurrentChar(function(c) {
                    return c + 1;
                });
            }, currentChar === 0 ? 200 : 50);
            return function() {
                return clearTimeout(timer1);
            };
        }
        setCurrentLine(function(l) {
            return l + 1;
        });
        setCurrentChar(0);
        return undefined;
    }, [
        currentLine,
        currentChar
    ]);
    var renderLine = function(line, index) {
        var targetLine = codeLines[index];
        var isTyping = currentLine === index && currentChar <= targetLine.length;
        if (index === 0) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Comment, {
                children: line
            });
        }
        if (index === 1) {
            if (!line) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cursor, {
                show: currentLine === 1
            });
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Keyword, {
                        children: "function"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FunctionName, {
                        children: "sum"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Punctuation, {
                        children: "("
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Variable, {
                        children: "a"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Punctuation, {
                        children: ": "
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Type, {
                        children: "number"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Punctuation, {
                        children: ", "
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Variable, {
                        children: "b"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Punctuation, {
                        children: ": "
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Type, {
                        children: "number"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Punctuation, {
                        children: [
                            ") ",
                            "{"
                        ]
                    }),
                    isTyping && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cursor, {
                        show: true
                    })
                ]
            });
        }
        if (index === 2) {
            if (!line) return null;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "  ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Keyword, {
                        children: "return"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Variable, {
                        children: "a + b"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Punctuation, {
                        children: ";"
                    }),
                    isTyping && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cursor, {
                        show: true
                    })
                ]
            });
        }
        if (index === 3) {
            if (!line) return null;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Punctuation, {
                        children: "}"
                    }),
                    isTyping && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cursor, {
                        show: true
                    })
                ]
            });
        }
        return line;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EditorWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EditorHeader, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WindowButtons, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WindowButton, {
                                color: "#ff5f56"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WindowButton, {
                                color: "#ffbd2e"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WindowButton, {
                                color: "#27ca40"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileName, {
                        children: "sum.ts"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditorContent, {
                children: displayedLines.map(function(line, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CodeLine, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineNumber, {
                                children: i + 1
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineContent, {
                                children: renderLine(line, i)
                            })
                        ]
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlowEffect, {})
        ]
    });
};
var AnimatedCodeEditor_float = (0,styled_components_browser_esm/* keyframes */.F4)(AnimatedCodeEditor_templateObject());
var blink = (0,styled_components_browser_esm/* keyframes */.F4)(AnimatedCodeEditor_templateObject1());
var EditorWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-0"
})(AnimatedCodeEditor_templateObject2(), AnimatedCodeEditor_float, device/* device.S */.U.S);
var EditorHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-1"
})(AnimatedCodeEditor_templateObject3());
var WindowButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-2"
})(AnimatedCodeEditor_templateObject4());
var WindowButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-3"
})(AnimatedCodeEditor_templateObject5(), function(props) {
    return props.color;
});
var FileName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-4"
})(AnimatedCodeEditor_templateObject6());
var EditorContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-5"
})(AnimatedCodeEditor_templateObject7(), device/* device.S */.U.S);
var CodeLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-6"
})(AnimatedCodeEditor_templateObject8());
var LineNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-7"
})(AnimatedCodeEditor_templateObject9());
var LineContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-8"
})(AnimatedCodeEditor_templateObject10());
var Comment = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-9"
})(AnimatedCodeEditor_templateObject11());
var Keyword = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-10"
})(AnimatedCodeEditor_templateObject12());
var FunctionName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-11"
})(AnimatedCodeEditor_templateObject13());
var Variable = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-12"
})(AnimatedCodeEditor_templateObject14());
var Type = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-13"
})(_templateObject15());
var Punctuation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-14"
})(_templateObject16());
var Cursor = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e19c6f93-15"
})(_templateObject17(), function(props) {
    return props.show ? "inline-block" : "none";
}, blink);
var GlowEffect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e19c6f93-16"
})(_templateObject18());
/* harmony default export */ var ai_page_AnimatedCodeEditor = (AnimatedCodeEditor);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/AiCTAButton.tsx



function AiCTAButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    AiCTAButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var AiCTAButton = function(param) {
    var courseOverview = param.courseOverview, _variant = param.variant, variant = _variant === void 0 ? "hero" : _variant, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice;
    var ref, ref1;
    var ref2 = (0,AuthUserContext/* useAuth */.a)(), user = ref2.user, isLoading = ref2.isLoading;
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {});
    var states = utils/* getCourseProductStates */.D0(courseOverview, user);
    var price = (((ref = courseOverview.courseProducts[0]) === null || ref === void 0 ? void 0 : ref.price) || 0) / 100;
    var productId = (ref1 = courseOverview.courseProducts[0]) === null || ref1 === void 0 ? void 0 : ref1.productId;
    var continueUrl = utils/* getTakeCourseUrl */.uM(courseOverview);
    var getContinueText = function() {
        return courseOverview.userProgressMetadata ? "Pokračovať v kurze" : "Spustiť kurz";
    };
    var getBuyText = function() {
        if (!showPrice) return "K\xfapiť kurz";
        if (variant === "finalCta") return "K\xfapiť kurz za ".concat(price, " EUR");
        return "K\xfapiť kurz - ".concat(price, " EUR");
    };
    var getButtonProps = function() {
        switch(variant){
            case "hero":
                return {
                    size: "large",
                    bold: true
                };
            case "pricing":
                return {
                    size: "very-large",
                    bold: true
                };
            case "finalCta":
                return {
                    size: "very-large",
                    bold: true
                };
            case "sticky":
                return {
                    size: "large",
                    bold: true
                };
            default:
                return {
                    size: "large",
                    bold: true
                };
        }
    };
    var buttonProps = getButtonProps();
    // User owns the course (paid or free)
    if (states.hasActiveProductsAndIsOwnedByUser) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: {
                pathname: continueUrl,
                query: {
                    autoplay: "false"
                }
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AiCTAButton_StyledButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "accent"
            }, buttonProps), {
                children: getContinueText()
            }))
        });
    }
    // Paid course but user doesn't own it
    if (states.hasActiveProductsButIsNotOwnedByUser) {
        if (!productId) return null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: routes/* routes.checkout.courseProduct */._.checkout.courseProduct(courseOverview.slug, productId),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AiCTAButton_StyledButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "accent"
            }, buttonProps), {
                iconBefore: variant === "sticky" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineShoppingCart */.nxQ, {}) : undefined,
                children: getBuyText()
            }))
        });
    }
    // Free course and user is logged in
    if (states.hasNoActiveProductsAndIsLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: {
                pathname: continueUrl,
                query: {
                    autoplay: "false"
                }
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AiCTAButton_StyledButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "accent"
            }, buttonProps), {
                children: getContinueText()
            }))
        });
    }
    // Free course but user is not logged in
    if (states.hasNoActiveProductsAndIsNotLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
            href: routes/* routes.login.redirectUri */._.login.redirectUri( true ? encodeURIComponent(location.pathname) : 0),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AiCTAButton_StyledButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "accent"
            }, buttonProps), {
                children: "Pre spustenie kurzu sa najprv prihl\xe1s"
            }))
        });
    }
    return null;
};
var AiCTAButton_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-81d9d3a8-0"
})(AiCTAButton_templateObject());
/* harmony default export */ var ai_page_AiCTAButton = (AiCTAButton);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background: linear-gradient(135deg, var(--color-accent), #4f8fef, #00b8d4);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  padding: 2px 0;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: var(--color-primary);\n  border-radius: 16px;\n  padding: 32px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 16px;\n    padding: 2px;\n    background: linear-gradient(135deg, var(--color-accent), #4f8fef, #00b8d4);\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 80px 0;\n  position: relative;\n\n  @media ",
        " {\n    padding: 48px 0;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 0.6s ease-out forwards;\n  animation-delay: ",
        "ms;\n  opacity: 0;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: 48px;\n\n  @media ",
        " {\n    margin-bottom: 32px;\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 0.3s ease-out;\n\n  &:hover {\n    transform: translateY(-8px);\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  min-width: ",
        ";\n  border-radius: 10px;\n  background: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease-out;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    color: var(--color-accent);\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  background: ",
        ";\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(126, 80, 230, 0.1) 0%,\n    rgba(79, 143, 239, 0.1) 50%,\n    rgba(0, 184, 212, 0.1) 100%\n  );\n  pointer-events: none;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 8px;\n  background: var(--color-shadow);\n  border-radius: 9999px;\n  overflow: hidden;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: ",
        ";\n  background: linear-gradient(90deg, var(--color-accent), #4f8fef, #00b8d4);\n  border-radius: 9999px;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 6px;\n  height: 6px;\n  min-width: 6px;\n  border-radius: 50%;\n  background: var(--color-accent);\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


// Gradient text effect
var GradientText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-41c2855f-0"
})(styles_templateObject());
// Gradient border card
var GradientBorderCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-1"
})(styles_templateObject1());
// Section wrapper with consistent padding
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-41c2855f-2"
})(styles_templateObject2(), device/* device.S */.U.S);
// Container with max-width
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-3"
})(styles_templateObject3());
// Fade-in animation
var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject4());
var AnimatedElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-4"
})(styles_templateObject5(), fadeIn, function(props) {
    return props.delay || 0;
});
// Scale-in animation
var scaleIn = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject6());
// Float animation for code editor
var styles_float = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject7());
// Section title wrapper
var SectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-5"
})(styles_templateObject8(), device/* device.S */.U.S);
// Card hover effect mixin (as a styled component)
var HoverCard = (0,styled_components_browser_esm/* default */.ZP)(GradientBorderCard).withConfig({
    componentId: "sc-41c2855f-6"
})(styles_templateObject9());
// Feature item with icon
var FeatureItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-7"
})(styles_templateObject10());
var FeatureIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-8"
})(styles_templateObject11(), function(props) {
    return props.size || "40px";
}, function(props) {
    return props.size || "40px";
}, function(props) {
    return props.size || "40px";
}, function(props) {
    return props.bgColor || "rgba(126, 80, 230, 0.1)";
});
// Badge component
var Badge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-41c2855f-9"
})(styles_templateObject12(), function(props) {
    return props.bgColor || "var(--color-accent)";
});
// Gradient background overlay
var GradientOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-10"
})(styles_templateObject13());
// Progress bar
var ProgressBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-11"
})(styles_templateObject14());
var ProgressBarFill = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-12"
})(styles_templateObject15(), function(props) {
    return props.width;
});
// Bullet point
var BulletPoint = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41c2855f-13"
})(styles_templateObject16());

;// CONCATENATED MODULE: ./src/components/misc/ai-page/HeroSection.tsx

function HeroSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding-top: 40px;\n  padding-bottom: 40px;\n\n  @media ",
        " {\n    min-height: auto;\n    padding-top: 24px;\n  }\n"
    ]);
    HeroSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px;\n  align-items: center;\n\n  @media ",
        " {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n"
    ]);
    HeroSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  @media ",
        " {\n    order: 2;\n  }\n"
    ]);
    HeroSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    order: 1;\n  }\n"
    ]);
    HeroSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeroSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  color: var(--color-grey);\n  line-height: 1.5;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    HeroSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeroSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 16px;\n"
    ]);
    HeroSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeroSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    HeroSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HeroSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n  flex-wrap: wrap;\n  color: var(--color-grey);\n  margin-top: 8px;\n\n  @media ",
        " {\n    gap: 16px;\n  }\n"
    ]);
    HeroSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HeroSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    HeroSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HeroSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n"
    ]);
    HeroSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HeroSection_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    HeroSection_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

















var HeroSection = function(param) {
    var courseOverview = param.courseOverview, lecturesCount = param.lecturesCount;
    var courseDuration = utils/* formatDurationFromMinutes */.BQ(courseOverview.courseDurationMinutes);
    var router = (0,next_router.useRouter)();
    var scrollToContent = function() {
        var ref;
        (ref = document.getElementById("content")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientOverlay, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroGrid, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroContent, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    delay: 0,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Heading/* default */.Z, {
                                        variant: "h1",
                                        children: [
                                            "Profesion\xe1lne",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientText, {
                                                children: "programovanie s AI"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    delay: 100,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                                        children: courseOverview.shortDescription
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ValueProps, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                            delay: 200,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ValueProp, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureIconWrapper, {
                                                        bgColor: "rgba(126, 80, 230, 0.1)",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineThunderbolt */.xtp, {})
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                        size: "large",
                                                        children: "Programuj 2x r\xfdchlejšie"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                            delay: 300,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ValueProp, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureIconWrapper, {
                                                        bgColor: "rgba(79, 143, 239, 0.1)",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineAim */.Ry3, {
                                                            style: {
                                                                color: "#4F8FEF"
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                        size: "large",
                                                        children: "Od z\xe1kladov po pokročil\xe9 techniky"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                            delay: 400,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ValueProp, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureIconWrapper, {
                                                        bgColor: "rgba(0, 184, 212, 0.1)",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineRocket */.HiV, {
                                                            style: {
                                                                color: "#00B8D4"
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                        size: "large",
                                                        children: "Praktick\xe9 projekty v JS/TS, C#, Java"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    delay: 500,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SocialProof, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingWrapper, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating/* default */.Z, {
                                                    readOnly: true,
                                                    value: courseOverview.reviewsOverview.averageRating
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                                color: "inherit",
                                                children: [
                                                    lecturesCount,
                                                    " ",
                                                    utils/* numOfLecturesText */.Wg(lecturesCount),
                                                    " |",
                                                    " ",
                                                    courseDuration
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorInfo, {
                                                onClick: function() {
                                                    return router.push(routes/* routes.lektor.slug */._.lektor.slug(courseOverview.author.slug));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
                                                        altName: courseOverview.author.name,
                                                        src: courseOverview.author.imageUrl,
                                                        sizePx: 32
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                        size: "small",
                                                        children: courseOverview.author.name
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    delay: 600,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CTAButtons, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_AiCTAButton, {
                                                courseOverview: courseOverview,
                                                variant: "hero"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                variant: "outline",
                                                size: "large",
                                                onClick: scrollToContent,
                                                children: "Pozrieť obsah"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroSection_EditorWrapper, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_AnimatedCodeEditor, {})
                        })
                    ]
                })
            })
        ]
    });
};
var HeroWrapper = (0,styled_components_browser_esm/* default */.ZP)(Section).withConfig({
    componentId: "sc-7fa87841-0"
})(HeroSection_templateObject(), device/* device.S */.U.S);
var HeroGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-1"
})(HeroSection_templateObject1(), device/* device.M */.U.M);
var HeroContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-2"
})(HeroSection_templateObject2(), device/* device.M */.U.M);
var HeroSection_EditorWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-3"
})(HeroSection_templateObject3(), device/* device.M */.U.M);
var Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7fa87841-4"
})(HeroSection_templateObject4(), device/* device.S */.U.S);
var ValueProps = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-5"
})(HeroSection_templateObject5());
var ValueProp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-6"
})(HeroSection_templateObject6());
var SocialProof = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7fa87841-7"
})(HeroSection_templateObject7(), device/* device.S */.U.S);
var RatingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-8"
})(HeroSection_templateObject8());
var AuthorInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-9"
})(HeroSection_templateObject9());
var CTAButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7fa87841-10"
})(HeroSection_templateObject10(), device/* device.S */.U.S);
/* harmony default export */ var ai_page_HeroSection = (HeroSection);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/ComparisonSection.tsx

function ComparisonSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: var(--color-grey);\n  text-align: center;\n  margin-top: 16px;\n"
    ]);
    ComparisonSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  max-width: 1000px;\n  margin: 0 auto;\n\n  @media ",
        " {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n"
    ]);
    ComparisonSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.3s ease-out;\n\n  &:hover {\n    transform: translateY(-8px);\n  }\n"
    ]);
    ComparisonSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 128px;\n  height: 128px;\n  background: radial-gradient(\n    circle,\n    rgba(126, 80, 230, 0.2) 0%,\n    transparent 70%\n  );\n  border-radius: 50%;\n  filter: blur(30px);\n"
    ]);
    ComparisonSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n  position: relative;\n"
    ]);
    ComparisonSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n\n  svg {\n    width: 24px;\n    height: 24px;\n    color: ",
        ";\n  }\n"
    ]);
    ComparisonSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n"
    ]);
    ComparisonSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n\n  > svg {\n    width: 20px;\n    height: 20px;\n    min-width: 20px;\n    color: var(--color-grey);\n    margin-top: 4px;\n  }\n"
    ]);
    ComparisonSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ComparisonSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  color: var(--color-grey);\n"
    ]);
    ComparisonSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var withoutAIItems = [
    {
        icon: index_esm/* AiOutlineClockCircle */.cjn,
        title: "8 hod\xedn na feature",
        description: "Pomal\xfd development cyklus"
    },
    {
        icon: index_esm/* AiOutlineBook */.SRW,
        title: "Stack Overflow hunting",
        description: "Manu\xe1lne hľadanie riešen\xed"
    },
    {
        icon: index_esm/* AiOutlineBug */.cuL,
        title: "Debugging hell",
        description: "ťažk\xe9 hľadanie bugov"
    },
    {
        icon: index_esm/* AiOutlineBook */.SRW,
        title: "Čitanie dokument\xe1cie",
        description: "Časovo n\xe1ročn\xe9 št\xfadium"
    },
    {
        icon: index_esm/* AiOutlineClockCircle */.cjn,
        title: "Opakuj\xfaca sa pr\xe1ca",
        description: "Manu\xe1lne p\xedsanie boilerplate"
    }, 
];
var withAIItems = [
    {
        icon: index_esm/* AiOutlineThunderbolt */.xtp,
        title: "4 hodiny na feature",
        description: "2x r\xfdchlejš\xed development",
        color: "var(--color-accent)"
    },
    {
        icon: index_esm/* AiOutlineRobot */.LAw,
        title: "Asistent priamo v IDE",
        description: "Okamžit\xe9 odpovede",
        color: "#4F8FEF"
    },
    {
        icon: index_esm/* AiOutlineCheck */.bzc,
        title: "AI Code review",
        description: "Automaticka detekcia chyb",
        color: "#00B8D4"
    },
    {
        icon: index_esm/* AiOutlineThunderbolt */.xtp,
        title: "Instant suggestions",
        description: "Inteligentne autocomplete",
        color: "var(--color-accent)"
    },
    {
        icon: index_esm/* AiOutlineSmile */.XTs,
        title: "Automation",
        description: "Generovanie boilerplate kodu",
        color: "#4F8FEF"
    }, 
];
var ComparisonSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTitle, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                variant: "h2",
                                align: "center",
                                children: "Ak\xfd je rozdiel?"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 100,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComparisonSection_Subtitle, {
                                children: "Porovnanie tradičn\xe9ho a AI-powered pr\xedstupu"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsGrid, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 200,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ComparisonCard, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircle, {
                                                variant: "danger",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineClose */.oHP, {})
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                                variant: "h4",
                                                children: "Bez AI n\xe1strojov"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemsList, {
                                        children: withoutAIItems.map(function(item, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ComparisonSection_Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(item.icon, {}),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemContent, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                weight: "bold",
                                                                children: item.title
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                size: "small",
                                                                color: "inherit",
                                                                children: item.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 400,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ComparisonCard, {
                                highlight: true,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComparisonSection_GlowEffect, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircle, {
                                                variant: "success",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineCheck */.bzc, {})
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                                variant: "h4",
                                                children: "S AI n\xe1strojmi"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemsList, {
                                        children: withAIItems.map(function(item, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ComparisonSection_Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(item.icon, {
                                                        style: {
                                                            color: item.color
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemContent, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                weight: "bold",
                                                                style: {
                                                                    color: item.color
                                                                },
                                                                children: item.title
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                size: "small",
                                                                color: "inherit",
                                                                children: item.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var ComparisonSection_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-70b5253d-0"
})(ComparisonSection_templateObject());
var CardsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-1"
})(ComparisonSection_templateObject1(), device/* device.M */.U.M);
var ComparisonCard = (0,styled_components_browser_esm/* default */.ZP)(GradientBorderCard).withConfig({
    componentId: "sc-70b5253d-2"
})(ComparisonSection_templateObject2());
var ComparisonSection_GlowEffect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-3"
})(ComparisonSection_templateObject3());
var CardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-4"
})(ComparisonSection_templateObject4());
var IconCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-5"
})(ComparisonSection_templateObject5(), function(props) {
    return props.variant === "danger" ? "rgba(203, 32, 65, 0.1)" : "rgba(126, 80, 230, 0.1)";
}, function(props) {
    return props.variant === "danger" ? "var(--color-danger)" : "var(--color-accent)";
});
var ItemsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-6"
})(ComparisonSection_templateObject6());
var ComparisonSection_Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-7"
})(ComparisonSection_templateObject7());
var ItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70b5253d-8"
})(ComparisonSection_templateObject8());
/* harmony default export */ var ai_page_ComparisonSection = (ComparisonSection);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/ToolsSection.tsx

function ToolsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: var(--color-grey);\n  text-align: center;\n  margin-top: 16px;\n"
    ]);
    ToolsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media ",
        " {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    ToolsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: transform 0.3s ease-out;\n  color: var(--color-grey);\n  height: 100%;\n\n  &:hover {\n    transform: translateY(-8px) scale(1.02);\n  }\n"
    ]);
    ToolsSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n"
    ]);
    ToolsSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  background: var(--color-primary);\n  border: 1px solid var(--color-shadow);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease-out;\n\n  svg {\n    width: 28px;\n    height: 28px;\n    color: var(--color-accent);\n  }\n\n  ",
        ":hover & {\n    transform: scale(1.1);\n  }\n"
    ]);
    ToolsSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    ToolsSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    ToolsSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ToolsSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    ToolsSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}








var tools = [
    {
        name: "GitHub Copilot",
        icon: index_esm/* AiOutlineGithub */.idJ,
        description: "Tvoj AI p\xe1rov\xfd program\xe1tor priamo v editore",
        level: "Začiatočn\xedk",
        levelColor: "#4CBF6B",
        features: [
            "Autocomplete k\xf3du",
            "Generovanie funkci\xed",
            "Code suggestions",
            "Dokument\xe1cia k\xf3du", 
        ],
        gradient: "from-green-500/20 to-blue-500/20"
    },
    {
        name: "Cursor IDE",
        icon: index_esm/* AiOutlineCode */.B1P,
        description: "Ultim\xe1tne AI IDE pre modern\xfdch v\xfdvoj\xe1rov",
        level: "Pokročil\xfd",
        levelColor: "#4F8FEF",
        features: [
            "Agentov\xe9 programovanie",
            "Multi-file editing",
            "AI refactoring",
            "MCP servery", 
        ],
        gradient: "from-blue-500/20 to-purple-500/20"
    },
    {
        name: "Claude Code",
        icon: index_esm/* AiOutlineStar */.y5j,
        description: "Najv\xfdkonnejš\xed AI asistent pre komplexn\xe9 \xfalohy",
        level: "Expert",
        levelColor: "var(--color-accent)",
        features: [
            "Komplexn\xe9 projekty",
            "Architektonick\xe9 rozhodnutia",
            "AI Code review",
            "Best practices", 
        ],
        gradient: "from-purple-500/20 to-pink-500/20"
    }, 
];
var ToolsSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTitle, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                variant: "h2",
                                align: "center",
                                children: "Čo sa nauč\xedš ovl\xe1dať?"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 100,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolsSection_Subtitle, {
                                children: "Praktick\xe9 ovl\xe1danie top AI n\xe1strojov pre program\xe1torov"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolsGrid, {
                    children: tools.map(function(tool, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 200 + index * 150,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToolCard, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToolHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tool.icon, {})
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                                variant: "h4",
                                                children: tool.name
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                                                bgColor: tool.levelColor,
                                                children: tool.level
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        color: "inherit",
                                        children: tool.description
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeaturesSection, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                size: "small",
                                                weight: "bold",
                                                children: "Čo rieši:"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturesList, {
                                                children: tool.features.map(function(feature) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Feature, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulletPoint, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                size: "small",
                                                                color: "inherit",
                                                                children: feature
                                                            })
                                                        ]
                                                    }, feature);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, tool.name);
                    })
                })
            ]
        })
    });
};
var ToolsSection_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-e609df9-0"
})(ToolsSection_templateObject());
var ToolsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e609df9-1"
})(ToolsSection_templateObject1(), device/* device.M */.U.M, device/* device.S */.U.S);
var ToolCard = (0,styled_components_browser_esm/* default */.ZP)(GradientBorderCard).withConfig({
    componentId: "sc-e609df9-2"
})(ToolsSection_templateObject2());
var ToolHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e609df9-3"
})(ToolsSection_templateObject3());
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e609df9-4"
})(ToolsSection_templateObject4(), ToolCard);
var FeaturesSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e609df9-5"
})(ToolsSection_templateObject5());
var FeaturesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e609df9-6"
})(ToolsSection_templateObject6());
var Feature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e609df9-7"
})(ToolsSection_templateObject7());
/* harmony default export */ var ai_page_ToolsSection = (ToolsSection);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/CourseContentSection.tsx

function CourseContentSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: var(--color-grey);\n  text-align: center;\n  margin-top: 16px;\n"
    ]);
    CourseContentSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 600px;\n  margin: 32px auto 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  color: var(--color-grey);\n"
    ]);
    CourseContentSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 800px;\n  margin: 0 auto;\n"
    ]);
    CourseContentSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    CourseContentSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: var(--color-primary);\n  border-radius: 12px;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 12px;\n    padding: 2px;\n    background: linear-gradient(135deg, var(--color-accent), #4f8fef, #00b8d4);\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n  }\n"
    ]);
    CourseContentSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    CourseContentSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: unset;\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(126, 80, 230, 0.05);\n  }\n\n  @media ",
        " {\n    padding: 16px;\n  }\n"
    ]);
    CourseContentSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    CourseContentSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  background: rgba(126, 80, 230, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease-out;\n\n  svg {\n    width: 24px;\n    height: 24px;\n    color: var(--color-accent);\n  }\n\n  ",
        ":hover & {\n    transform: scale(1.1);\n  }\n\n  @media ",
        " {\n    width: 40px;\n    height: 40px;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n"
    ]);
    CourseContentSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    CourseContentSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-secondary);\n\n  @media ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    CourseContentSection_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: var(--color-grey);\n"
    ]);
    CourseContentSection_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  color: var(--color-secondary);\n  transition: transform 0.3s ease-out;\n  flex-shrink: 0;\n\n  [data-state='open'] & {\n    transform: rotate(180deg);\n  }\n"
    ]);
    CourseContentSection_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: 0;\n    opacity: 0;\n  }\n  to {\n    height: var(--radix-accordion-content-height);\n    opacity: 1;\n  }\n"
    ]);
    CourseContentSection_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: var(--radix-accordion-content-height);\n    opacity: 1;\n  }\n  to {\n    height: 0;\n    opacity: 0;\n  }\n"
    ]);
    CourseContentSection_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n\n  &[data-state='open'] {\n    animation: ",
        " 0.3s ease-out forwards;\n  }\n\n  &[data-state='closed'] {\n    animation: ",
        " 0.3s ease-out forwards;\n  }\n"
    ]);
    CourseContentSection_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px 20px;\n\n  @media ",
        " {\n    padding: 0 16px 16px;\n  }\n"
    ]);
    CourseContentSection_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    CourseContentSection_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function CourseContentSection_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CourseContentSection_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--color-shadow);\n  cursor: ",
        ";\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: var(--color-grey);\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background-color: var(--color-accent);\n  color: var(--color-primary);\n  font-weight: 600;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}













var CourseContentSection = function(param) {
    var courseOverview = param.courseOverview;
    var ref;
    var user = (0,AuthUserContext/* useAuth */.a)().user;
    var ref1 = (0,react.useState)(null), previewLectureInModal = ref1[0], setPreviewLectureInModal = ref1[1];
    var chapters = courseOverview.chapters, courseDurationMinutes = courseOverview.courseDurationMinutes;
    var lecturesCount = chapters.flatMap(function(chapter) {
        return chapter.lectures;
    }).length;
    var formattedDuration = utils/* formatDurationFromMinutes */.BQ(courseDurationMinutes);
    var states = utils/* getCourseProductStates */.D0(courseOverview, user);
    var isLectureClickable = function(lecture) {
        if (states.hasNoActiveProductsAndIsLoggedIn || states.hasActiveProductsAndIsOwnedByUser) return true;
        var allowPreviewWhenPaid = lecture.allowPreviewWhenPaid;
        if (allowPreviewWhenPaid && states.hasActiveProductsButIsNotOwnedByUser) return true;
        return false;
    };
    var shouldPreviewLectureForPaidCourse = function(lecture) {
        return isLectureClickable(lecture) && states.hasActiveProductsButIsNotOwnedByUser;
    };
    var handleLectureOnClick = function(e, lecture) {
        e.preventDefault();
        e.stopPropagation();
        if (shouldPreviewLectureForPaidCourse(lecture)) {
            setPreviewLectureInModal(lecture);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
                id: "content",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTitle, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                        variant: "h2",
                                        align: "center",
                                        children: "Čo kurz obsahuje?"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    delay: 100,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseContentSection_Subtitle, {
                                        children: [
                                            "Kompletn\xfd obsah kurzu rozdelen\xfd do ",
                                            chapters.length,
                                            " sekci\xed"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                                    delay: 200,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProgressInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                alignSelf: "stretch",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                                        size: "small",
                                                        color: "inherit",
                                                        children: [
                                                            "Celkov\xe1 dĺžka: ",
                                                            formattedDuration
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                                        size: "small",
                                                        color: "inherit",
                                                        children: [
                                                            lecturesCount,
                                                            " ",
                                                            utils/* numOfLecturesText */.Wg(lecturesCount)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressBar, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressBarFill, {
                                                    width: "0%"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 300,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionWrapper, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseContentSection_AccordionRoot, {
                                    type: "multiple",
                                    defaultValue: [
                                        (ref = chapters[0]) === null || ref === void 0 ? void 0 : ref.id.toString()
                                    ],
                                    children: chapters.map(function(chapter) {
                                        var ref;
                                        var chapterLectureCount = chapter.lectures.length;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionItem, {
                                            value: chapter.id.toString(),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionHeader, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TriggerContent, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChapterIcon, {
                                                                        children: utils/* getLectureTypeIcon */.vW(((ref = chapter.lectures[0]) === null || ref === void 0 ? void 0 : ref.lectureType) || "VIDEO")
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChapterInfo, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChapterTitle, {
                                                                                children: chapter.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChapterMeta, {
                                                                                children: [
                                                                                    chapterLectureCount,
                                                                                    " ",
                                                                                    utils/* numOfLecturesText */.Wg(chapterLectureCount),
                                                                                    " |",
                                                                                    " ",
                                                                                    chapter.chapterDurationMinutes,
                                                                                    " ",
                                                                                    utils/* numOfMinutesText */.m0(chapter.chapterDurationMinutes)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronIcon, {})
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseContentSection_AccordionContent, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentInner, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LecturesList, {
                                                            children: chapter.lectures.map(function(lecture) {
                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LectureItem, {
                                                                    clickable: shouldPreviewLectureForPaidCourse(lecture),
                                                                    onClick: function(e) {
                                                                        return handleLectureOnClick(e, lecture);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulletPoint, {}),
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LectureText, {
                                                                            size: "small",
                                                                            children: lecture.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LectureMetaWrapper, {
                                                                            children: [
                                                                                lecture.videoDurationSeconds > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LectureDuration, {
                                                                                    children: utils/* formatDurationFromSeconds */.Ae(lecture.videoDurationSeconds)
                                                                                }),
                                                                                shouldPreviewLectureForPaidCourse(lecture) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreviewBadge, {
                                                                                    children: "n\xe1hľad"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, lecture.id);
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }, chapter.id);
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            previewLectureInModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lecture_LecturePreview, {
                lecture: previewLectureInModal,
                onClosePreview: function() {
                    return setPreviewLectureInModal(null);
                }
            })
        ]
    });
};
var CourseContentSection_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-e8ace701-0"
})(CourseContentSection_templateObject());
var ProgressInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-1"
})(CourseContentSection_templateObject1());
var AccordionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-2"
})(CourseContentSection_templateObject2());
var CourseContentSection_AccordionRoot = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Root */.fC).withConfig({
    componentId: "sc-e8ace701-3"
})(CourseContentSection_templateObject3());
var AccordionItem = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Item */.ck).withConfig({
    componentId: "sc-e8ace701-4"
})(CourseContentSection_templateObject4());
var AccordionHeader = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Header */.h4).withConfig({
    componentId: "sc-e8ace701-5"
})(CourseContentSection_templateObject5());
var AccordionTrigger = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Trigger */.xz).withConfig({
    componentId: "sc-e8ace701-6"
})(CourseContentSection_templateObject6(), device/* device.S */.U.S);
var TriggerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-7"
})(CourseContentSection_templateObject7());
var ChapterIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-8"
})(CourseContentSection_templateObject8(), AccordionTrigger, device/* device.S */.U.S);
var ChapterInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-9"
})(CourseContentSection_templateObject9());
var ChapterTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e8ace701-10"
})(CourseContentSection_templateObject10(), device/* device.S */.U.S);
var ChapterMeta = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e8ace701-11"
})(CourseContentSection_templateObject11());
var ChevronIcon = (0,styled_components_browser_esm/* default */.ZP)(bi_index_esm/* BiChevronDown */.OrA).withConfig({
    componentId: "sc-e8ace701-12"
})(CourseContentSection_templateObject12());
var CourseContentSection_openContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(CourseContentSection_templateObject13());
var CourseContentSection_closeContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(CourseContentSection_templateObject14());
var CourseContentSection_AccordionContent = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Content */.VY).withConfig({
    componentId: "sc-e8ace701-13"
})(CourseContentSection_templateObject15(), CourseContentSection_openContentAnimation, CourseContentSection_closeContentAnimation);
var ContentInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-14"
})(CourseContentSection_templateObject16(), device/* device.S */.U.S);
var LecturesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-15"
})(CourseContentSection_templateObject17());
var LectureText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-e8ace701-16"
})(CourseContentSection_templateObject18());
var LectureItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-17"
})(_templateObject19(), function(props) {
    return props.clickable ? "pointer" : "default";
}, function(props) {
    return props.clickable && "\n      color: var(--color-accent);\n\n      ".concat(LectureText, " {\n        color: var(--color-accent);\n      }\n    ");
});
var LectureMetaWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8ace701-18"
})(_templateObject20());
var LectureDuration = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e8ace701-19"
})(_templateObject21());
var PreviewBadge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e8ace701-20"
})(_templateObject22());
/* harmony default export */ var ai_page_CourseContentSection = (CourseContentSection);

// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(54361);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(40935);
;// CONCATENATED MODULE: ./src/components/misc/ai-page/PersonasSection.tsx

function PersonasSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: var(--color-grey);\n  text-align: center;\n  margin-top: 16px;\n"
    ]);
    PersonasSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  max-width: 1100px;\n  margin: 0 auto;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media ",
        " {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    PersonasSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n  transition: transform 0.3s ease-out;\n  height: 100%;\n\n  &:hover {\n    transform: translateY(-8px) scale(1.02);\n  }\n"
    ]);
    PersonasSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 80px;\n  border-radius: 16px;\n  background: var(--color-primary);\n  border: 2px solid var(--color-shadow);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease-out;\n\n  svg {\n    width: 40px;\n    height: 40px;\n  }\n\n  ",
        ":hover & {\n    transform: scale(1.1);\n  }\n"
    ]);
    PersonasSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: var(--color-grey);\n  font-style: italic;\n"
    ]);
    PersonasSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    PersonasSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    PersonasSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  text-align: left;\n  color: var(--color-grey);\n"
    ]);
    PersonasSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PersonasSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  color: var(--color-accent);\n  margin-top: 2px;\n"
    ]);
    PersonasSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}











var personas = [
    {
        icon: io5_index_esm/* IoSchoolOutline */.bhx,
        title: "Junior Developer",
        quote: "Chcem byť efekt\xedvnejš\xed",
        iconColor: "#4CBF6B",
        requirements: [
            "Z\xe1klady Git",
            "Znalosti IDE",
            "Jeden jazyk (JS/C#/Java)"
        ]
    },
    {
        icon: bi_index_esm/* BiBriefcase */.eV_,
        title: "Senior Developer",
        quote: "Držať krok s AI",
        iconColor: "#4F8FEF",
        requirements: [
            "Zv\xfdšiť produktivitu",
            "Zostať konkurencieschopn\xfd",
            "Vedieť využiť AI n\xe1stroje", 
        ]
    },
    {
        icon: hi_index_esm/* HiOutlineUserGroup */.TSD,
        title: "Tech Lead",
        quote: "Zv\xfdšiť produktivitu t\xedmu",
        iconColor: "var(--color-accent)",
        requirements: [
            "Implementovať AI v t\xedme",
            "Best practices",
            "Školenie členov t\xedmu", 
        ]
    }, 
];
var PersonasSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTitle, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                variant: "h2",
                                align: "center",
                                children: "Je tento kurz pre teba?"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 100,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonasSection_Subtitle, {
                                children: "Kurz je vhodn\xfd pre rozne \xfarovne v\xfdvoj\xe1rov"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonasGrid, {
                    children: personas.map(function(persona, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 200 + index * 150,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonaCard, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonasSection_IconWrapper, {
                                        style: {
                                            borderColor: persona.iconColor
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(persona.icon, {
                                            style: {
                                                color: persona.iconColor
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                        variant: "h4",
                                        align: "center",
                                        children: persona.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Quote, {
                                        children: [
                                            '"',
                                            persona.quote,
                                            '"'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RequirementsSection, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                size: "small",
                                                weight: "bold",
                                                align: "center",
                                                children: "Potrebuješ:"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequirementsList, {
                                                children: persona.requirements.map(function(req) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Requirement, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckIcon, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                size: "small",
                                                                color: "inherit",
                                                                children: req
                                                            })
                                                        ]
                                                    }, req);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, persona.title);
                    })
                })
            ]
        })
    });
};
var PersonasSection_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-10509c71-0"
})(PersonasSection_templateObject());
var PersonasGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10509c71-1"
})(PersonasSection_templateObject1(), device/* device.M */.U.M, device/* device.S */.U.S);
var PersonaCard = (0,styled_components_browser_esm/* default */.ZP)(GradientBorderCard).withConfig({
    componentId: "sc-10509c71-2"
})(PersonasSection_templateObject2());
var PersonasSection_IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10509c71-3"
})(PersonasSection_templateObject3(), PersonaCard);
var Quote = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-10509c71-4"
})(PersonasSection_templateObject4());
var RequirementsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10509c71-5"
})(PersonasSection_templateObject5());
var RequirementsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10509c71-6"
})(PersonasSection_templateObject6());
var Requirement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-10509c71-7"
})(PersonasSection_templateObject7());
var CheckIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* AiOutlineCheck */.bzc).withConfig({
    componentId: "sc-10509c71-8"
})(PersonasSection_templateObject8());
/* harmony default export */ var ai_page_PersonasSection = (PersonasSection);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/PricingSection.tsx

function PricingSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 700px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n  padding: 48px;\n\n  @media ",
        " {\n    padding: 32px 24px;\n  }\n"
    ]);
    PricingSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PricingSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -50px;\n  right: -50px;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(\n    circle,\n    rgba(126, 80, 230, 0.3) 0%,\n    transparent 70%\n  );\n  border-radius: 50%;\n  filter: blur(40px);\n  pointer-events: none;\n"
    ]);
    PricingSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PricingSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -50px;\n  left: -50px;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(\n    circle,\n    rgba(0, 184, 212, 0.3) 0%,\n    transparent 70%\n  );\n  border-radius: 50%;\n  filter: blur(40px);\n  pointer-events: none;\n"
    ]);
    PricingSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PricingSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    PricingSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PricingSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    PricingSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PricingSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    PricingSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PricingSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 64px;\n  font-weight: 700;\n  line-height: 1.2;\n\n  @media ",
        " {\n    font-size: 48px;\n  }\n"
    ]);
    PricingSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PricingSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  color: var(--color-grey);\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--color-shadow);\n"
    ]);
    PricingSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PricingSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--color-shadow);\n"
    ]);
    PricingSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PricingSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    PricingSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PricingSection_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(126, 80, 230, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    color: var(--color-accent);\n  }\n"
    ]);
    PricingSection_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function PricingSection_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  flex-wrap: wrap;\n"
    ]);
    PricingSection_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function PricingSection_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-grey);\n  font-size: 14px;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    color: var(--color-accent);\n  }\n"
    ]);
    PricingSection_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}









var features = function(lecturesCount) {
    return [
        "".concat(lecturesCount, " video lekci\xed"),
        "Pr\xedstup k VS Code, Visual Studio, IntelliJ setupom",
        "Claude Code kompletn\xfd sprievodca",
        "Ultim\xe1tny workflow pre komplexn\xe9 \xfalohy",
        "Lifetime updates",
        "Pr\xedstup do komunity", 
    ];
};
var PricingSection = function(param) {
    var courseOverview = param.courseOverview;
    var ref;
    var price = (((ref = courseOverview.courseProducts[0]) === null || ref === void 0 ? void 0 : ref.price) || 0) / 100;
    var lecturesCount = courseOverview.chapters.flatMap(function(chapter) {
        return chapter.lectures;
    }).length;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingCard, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlowTopRight, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlowBottomLeft, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContent, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingSection_Header, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                            variant: "h3",
                                            align: "center",
                                            children: "\uD83C\uDFAF Chcem sa naučiť ovl\xe1dať AI n\xe1stroje"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceWrapper, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientText, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Price, {
                                                    children: [
                                                        price,
                                                        " EUR"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_AiCTAButton, {
                                    courseOverview: courseOverview,
                                    variant: "pricing",
                                    showPrice: false
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                    children: courseOverview.shortDescription
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingSection_FeaturesList, {
                                    children: features(lecturesCount).map(function(feature) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricingSection_Feature, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckCircle, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineCheck */.bzc, {})
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                    size: "large",
                                                    children: feature
                                                })
                                            ]
                                        }, feature);
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustBadges, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrustBadge, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineLock */.YfK, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                children: "Bezpečn\xe1 platba"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var PricingCard = (0,styled_components_browser_esm/* default */.ZP)(GradientBorderCard).withConfig({
    componentId: "sc-c4b37a7f-0"
})(PricingSection_templateObject(), device/* device.S */.U.S);
var GlowTopRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-1"
})(PricingSection_templateObject1());
var GlowBottomLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-2"
})(PricingSection_templateObject2());
var CardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-3"
})(PricingSection_templateObject3());
var PricingSection_Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-4"
})(PricingSection_templateObject4());
var PriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-5"
})(PricingSection_templateObject5());
var Price = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c4b37a7f-6"
})(PricingSection_templateObject6(), device/* device.S */.U.S);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c4b37a7f-7"
})(PricingSection_templateObject7());
var PricingSection_FeaturesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-8"
})(PricingSection_templateObject8());
var PricingSection_Feature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-9"
})(PricingSection_templateObject9());
var CheckCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-10"
})(PricingSection_templateObject10());
var TrustBadges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-11"
})(PricingSection_templateObject11());
var TrustBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b37a7f-12"
})(PricingSection_templateObject12());
/* harmony default export */ var ai_page_PricingSection = (PricingSection);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/FAQSection.tsx

function FAQSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: var(--color-grey);\n  text-align: center;\n  margin-top: 16px;\n"
    ]);
    FAQSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FAQSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 700px;\n  margin: 0 auto;\n"
    ]);
    FAQSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FAQSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    FAQSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FAQSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: var(--color-primary);\n  border-radius: 12px;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 12px;\n    padding: 2px;\n    background: linear-gradient(135deg, var(--color-accent), #4f8fef, #00b8d4);\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n  }\n"
    ]);
    FAQSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FAQSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    FAQSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FAQSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: unset;\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background: rgba(126, 80, 230, 0.05);\n  }\n\n  @media ",
        " {\n    padding: 16px;\n  }\n"
    ]);
    FAQSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FAQSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-secondary);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  @media ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    FAQSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FAQSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  color: var(--color-secondary);\n  transition: transform 0.3s ease-out;\n  flex-shrink: 0;\n\n  [data-state='open'] & {\n    transform: rotate(180deg);\n  }\n"
    ]);
    FAQSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function FAQSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: 0;\n    opacity: 0;\n  }\n  to {\n    height: var(--radix-accordion-content-height);\n    opacity: 1;\n  }\n"
    ]);
    FAQSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function FAQSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: var(--radix-accordion-content-height);\n    opacity: 1;\n  }\n  to {\n    height: 0;\n    opacity: 0;\n  }\n"
    ]);
    FAQSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function FAQSection_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n\n  &[data-state='open'] {\n    animation: ",
        " 0.3s ease-out forwards;\n  }\n\n  &[data-state='closed'] {\n    animation: ",
        " 0.3s ease-out forwards;\n  }\n"
    ]);
    FAQSection_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function FAQSection_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px 20px;\n  color: var(--color-grey);\n  line-height: 1.6;\n\n  @media ",
        " {\n    padding: 0 16px 16px;\n  }\n"
    ]);
    FAQSection_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}








var faqs = [
    {
        question: "Pre koho je kurz určen\xfd?",
        answer: "Kurz je určen\xfd pre program\xe1torov, ktor\xed už maj\xfa z\xe1kladn\xe9 programovacie sk\xfasenosti. " + "Nemus\xedš byť senior, ale mal/a by si vedieť pracovať vo svojom IDE " + "(VSCode, Visual Studio, IntelliJ IDEA alebo podobn\xe9), " + "rozumieť z\xe1kladom Git a GitHub a orientovať sa v k\xf3de svojho hlavn\xe9ho programovacieho jazyka."
    },
    {
        question: "Co všetko z\xedsk\xe1š?",
        answer: "Po zak\xfapen\xed kurzu z\xedsk\xe1š pr\xedstup ku všetk\xfdm vide\xe1m a materi\xe1lom. " + "Každ\xfd študent si ide vlastn\xfdm tempom a pozer\xe1 vide\xe1 kedy chce, v akom porad\xed chce."
    },
    {
        question: "M\xe1me z\xe1ujem o firemn\xe9 školenie",
        answer: "Ak m\xe1š z\xe1ujem o firemn\xe9 školenie, kontaktuj n\xe1s na info@streetofcode.sk. " + "Priprav\xedm v\xe1m ponuku do mailu pre školenie vo vašich priestoroch."
    },
    {
        question: "Ako dlho budem mať pr\xedstup ku kurzu?",
        answer: "Po zak\xfapen\xed kurzu budeš mať pr\xedstup ku všetk\xfdm materi\xe1lom navždy."
    },
    {
        question: "Ako m\xf4žem platit?",
        answer: "Platbu m\xf4žeš vykonať platobnou kartou. Po platbe z\xedsk\xe1š pr\xedstup ku kurzu ihneď. " + "Kurz bude sp\xe1rovan\xfd s tvoj\xedm \xfačtom na str\xe1nke. " + "Ak m\xe1š z\xe1ujem o in\xfa formu platby, alebo platbu na fakt\xfaru, kontaktuj n\xe1s na info@streetofcode.sk"
    }, 
];
var FAQSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTitle, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                variant: "h2",
                                align: "center",
                                children: "Čast\xe9 ot\xe1zky"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                            delay: 100,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQSection_Subtitle, {
                                children: "Odpovede na najčastejšie ot\xe1zky"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                    delay: 200,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQSection_AccordionRoot, {
                            type: "single",
                            collapsible: true,
                            defaultValue: "item-0",
                            children: faqs.map(function(faq, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FAQSection_AccordionItem, {
                                    value: "item-".concat(index),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQSection_AccordionHeader, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FAQSection_AccordionTrigger, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuestionText, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                role: "img",
                                                                "aria-label": "question",
                                                                children: "❓"
                                                            }),
                                                            " ",
                                                            faq.question
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQSection_ChevronIcon, {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQSection_AccordionContent, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnswerText, {
                                                children: faq.answer
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    })
                })
            ]
        })
    });
};
var FAQSection_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3a1e1c23-0"
})(FAQSection_templateObject());
var FAQWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3a1e1c23-1"
})(FAQSection_templateObject1());
var FAQSection_AccordionRoot = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Root */.fC).withConfig({
    componentId: "sc-3a1e1c23-2"
})(FAQSection_templateObject2());
var FAQSection_AccordionItem = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Item */.ck).withConfig({
    componentId: "sc-3a1e1c23-3"
})(FAQSection_templateObject3());
var FAQSection_AccordionHeader = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Header */.h4).withConfig({
    componentId: "sc-3a1e1c23-4"
})(FAQSection_templateObject4());
var FAQSection_AccordionTrigger = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Trigger */.xz).withConfig({
    componentId: "sc-3a1e1c23-5"
})(FAQSection_templateObject5(), device/* device.S */.U.S);
var QuestionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3a1e1c23-6"
})(FAQSection_templateObject6(), device/* device.S */.U.S);
var FAQSection_ChevronIcon = (0,styled_components_browser_esm/* default */.ZP)(bi_index_esm/* BiChevronDown */.OrA).withConfig({
    componentId: "sc-3a1e1c23-7"
})(FAQSection_templateObject7());
var FAQSection_openContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(FAQSection_templateObject8());
var FAQSection_closeContentAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(FAQSection_templateObject9());
var FAQSection_AccordionContent = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Content */.VY).withConfig({
    componentId: "sc-3a1e1c23-8"
})(FAQSection_templateObject10(), FAQSection_openContentAnimation, FAQSection_closeContentAnimation);
var AnswerText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3a1e1c23-9"
})(FAQSection_templateObject11(), device/* device.S */.U.S);
/* harmony default export */ var ai_page_FAQSection = (FAQSection);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/FinalCTA.tsx

function FinalCTA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n"
    ]);
    FinalCTA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinalCTA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(\n    circle,\n    rgba(126, 80, 230, 0.15) 0%,\n    transparent 70%\n  );\n  pointer-events: none;\n"
    ]);
    FinalCTA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinalCTA_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 700px;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n"
    ]);
    FinalCTA_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FinalCTA_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  color: var(--color-grey);\n  line-height: 1.5;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    FinalCTA_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FinalCTA_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-grey);\n  font-size: 14px;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    FinalCTA_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FinalCTA_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-accent);\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    FinalCTA_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var FinalCTA = function(param) {
    var courseOverview = param.courseOverview;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CTASection, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientOverlay, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RadialGlow, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedElement, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Heading/* default */.Z, {
                                variant: "h2",
                                align: "center",
                                children: [
                                    "Pripraven\xfd stať sa",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientText, {
                                        children: "produktivn\xfdm?"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinalCTA_Subtitle, {
                                children: "Začni programovať s AI n\xe1strojmi ešte dnes a zv\xfdš svoju produktivitu o 200%"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_AiCTAButton, {
                                courseOverview: courseOverview,
                                variant: "finalCta"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContactInfo, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineMail */.Dme, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        children: "M\xe1š ot\xe1zky? Nap\xedš na "
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactLink, {
                                        href: "mailto:info@streetofcode.sk",
                                        children: "info@streetofcode.sk"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var CTASection = (0,styled_components_browser_esm/* default */.ZP)(Section).withConfig({
    componentId: "sc-d3b95148-0"
})(FinalCTA_templateObject());
var RadialGlow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3b95148-1"
})(FinalCTA_templateObject1());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3b95148-2"
})(FinalCTA_templateObject2());
var FinalCTA_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d3b95148-3"
})(FinalCTA_templateObject3(), device/* device.S */.U.S);
var ContactInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3b95148-4"
})(FinalCTA_templateObject4());
var ContactLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-d3b95148-5"
})(FinalCTA_templateObject5());
/* harmony default export */ var ai_page_FinalCTA = (FinalCTA);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/StickyButton.tsx

function StickyButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    StickyButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StickyButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 32px;\n  right: 32px;\n  z-index: 50;\n  animation: ",
        " 0.3s ease-out;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    StickyButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StickyButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  padding: 16px;\n  background: rgba(var(--color-primary-rgb, 255, 255, 255), 0.8);\n  background: var(--color-primary);\n  backdrop-filter: blur(10px);\n  border-top: 1px solid var(--color-shadow);\n  animation: ",
        " 0.3s ease-out;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    StickyButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var StickyButton = function(param) {
    var courseOverview = param.courseOverview, hidden = param.hidden;
    var user = (0,AuthUserContext/* useAuth */.a)().user;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            setIsVisible(window.scrollY > 800);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var states = utils/* getCourseProductStates */.D0(courseOverview, user);
    // Only show sticky button when user needs to pay (paid course, not owned)
    if (!states.hasActiveProductsButIsNotOwnedByUser) return null;
    if (!isVisible || hidden) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_AiCTAButton, {
                    courseOverview: courseOverview,
                    variant: "sticky"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_AiCTAButton, {
                    courseOverview: courseOverview,
                    variant: "sticky"
                })
            })
        ]
    });
};
var fadeInUp = (0,styled_components_browser_esm/* keyframes */.F4)(StickyButton_templateObject());
var DesktopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cee79fc7-0"
})(StickyButton_templateObject1(), fadeInUp, device/* device.M */.U.M);
var MobileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cee79fc7-1"
})(StickyButton_templateObject2(), fadeInUp, device/* device.M */.U.M);
/* harmony default export */ var ai_page_StickyButton = (StickyButton);

;// CONCATENATED MODULE: ./src/components/misc/ai-page/index.tsx

function ai_page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n"
    ]);
    ai_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ai_page_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 80px 24px;\n"
    ]);
    ai_page_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var AiCoursePage = function(param) {
    var courseOverview = param.courseOverview;
    var lecturesCount = courseOverview.chapters.flatMap(function(chapter) {
        return chapter.lectures;
    }).length;
    var pricingSectionRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isPricingVisible = ref[0], setIsPricingVisible = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (pricingSectionRef.current) {
                var hasReachedPricing = window.scrollY + window.innerHeight >= pricingSectionRef.current.offsetTop;
                setIsPricingVisible(hasReachedPricing);
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ai_page_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_HeroSection, {
                courseOverview: courseOverview,
                lecturesCount: lecturesCount
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_ComparisonSection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_ToolsSection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_CourseContentSection, {
                courseOverview: courseOverview
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_PersonasSection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                ref: pricingSectionRef,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_PricingSection, {
                    courseOverview: courseOverview
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_FAQSection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_FinalCTA, {
                courseOverview: courseOverview
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewsWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(course_review_CourseReviews, {
                    courseOverview: courseOverview
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page_StickyButton, {
                courseOverview: courseOverview,
                hidden: isPricingVisible
            })
        ]
    });
};
var ai_page_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-27bef03-0"
})(ai_page_templateObject());
var ReviewsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-27bef03-1"
})(ai_page_templateObject1());
/* harmony default export */ var ai_page = (AiCoursePage);

;// CONCATENATED MODULE: ./src/pages/kurzy/[slug]/index.tsx



function _slug_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    flex-direction: column;\n    gap: 32px;\n  }\n"
    ]);
    _slug_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _slug_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 50%;\n\n  h1 {\n    overflow-wrap: break-word;\n    word-break: break-word;\n  }\n\n  @media ",
        " {\n    max-width: 100%;\n    order: 2;\n  }\n"
    ]);
    _slug_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _slug_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 48px;\n"
    ]);
    _slug_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _slug_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 48px;\n  align-self: center;\n"
    ]);
    _slug_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _slug_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n  align-items: center;\n\n  cursor: ",
        ";\n\n  svg {\n    color: var(--color-secondary);\n    width: 28px;\n    height: 28px;\n  }\n"
    ]);
    _slug_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _slug_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 400px;\n  position: ",
        ";\n  top: 80px;\n\n  @media ",
        " {\n    position: static;\n  }\n\n  @media ",
        " {\n    align-self: center;\n    width: 100%;\n    order: 1;\n  }\n"
    ]);
    _slug_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _slug_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  aspect-ratio: 16 / 9;\n"
    ]);
    _slug_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _slug_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  margin-bottom: 8px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _slug_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _slug_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 0.2s ease-in-out;\n  &:hover {\n    cursor: pointer;\n    transform: scale(1.05);\n    transition: transform 0.2s ease-in-out;\n    opacity: 0.8;\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _slug_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

































var LazyCourseDescription = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 20325));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20325)
            ];
        }
    },
    ssr: false
});
var CourseDetailPage = function(param) {
    var slug = param.slug, courseOverview = param.courseOverview;
    var user = (0,AuthUserContext/* useAuth */.a)().user;
    var getCourseOverview = (0,api_courseOverview/* useGetCourseOverview */.W)(slug, !!user);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryGuard/* UserAndQueryGuard */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        user: user,
        fallbackData: courseOverview,
        fallbackComponent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavBar/* default */.Z, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageContentWrapper/* default */.Z, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                        direction: "column",
                        justifyContent: "center",
                        gap: "48px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                variant: "h3",
                                align: "center",
                                children: "Pre tento kurz nem\xe1š dostatočn\xe9 opr\xe1vnenie"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                href: routes/* routes.root */._.root,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                    variant: "h4",
                                    withAccentUnderline: true,
                                    children: "Prejsť na hlavn\xfa str\xe1nku"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }, getCourseOverview), {
        children: function(_courseOverview) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* default */.Z, {
                        title: "".concat(_courseOverview.name, " | Street of Code"),
                        description: _courseOverview.shortDescription,
                        url: (0,routes/* prefixWithHost */.O)(routes/* routes.kurzy.slug */._.kurzy.slug(_courseOverview.slug)),
                        imageUrl: _courseOverview.iconUrl
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavBar/* default */.Z, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseDetailContent, {
                        courseOverview: _courseOverview
                    })
                ]
            });
        }
    }));
};
var CourseDetailContent = function(param) {
    var courseOverview = param.courseOverview;
    var ref;
    var ref1 = (0,AuthUserContext/* useAuth */.a)(), user = ref1.user, isLoading = ref1.isLoading;
    var courseReviewsRef = (0,react.useRef)(null);
    var courseProductsRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), hasProductsInLocation = ref2[0], setHasProductsInLocation = ref2[1];
    var ref3 = (0,react.useState)(true), sidebarReviewsVisible = ref3[0], setSidebarReviewsVisible = ref3[1];
    var ref4 = (0,react.useState)(true), sidebarCardVisible = ref4[0], setSidebarCardVisible = ref4[1];
    (0,react.useEffect)(function() {
        var handleHashChange = function() {
            if (window.location.hash === "#products") {
                setHasProductsInLocation(true);
            } else {
                setHasProductsInLocation(false);
            }
        };
        setHasProductsInLocation(window.location.hash === "#products");
        window.addEventListener("hashchange", handleHashChange);
        return function() {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, [
        setHasProductsInLocation
    ]);
    (0,react.useEffect)(function() {
        if (hasProductsInLocation && courseProductsRef.current) {
            courseProductsRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        hasProductsInLocation,
        courseProductsRef
    ]);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (courseReviewsRef.current) {
                if (window.scrollY + window.innerHeight >= courseReviewsRef.current.offsetTop) {
                    setSidebarReviewsVisible(false);
                } else {
                    setSidebarReviewsVisible(true);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        courseReviewsRef
    ]);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (courseProductsRef.current) {
                if (window.scrollY + window.innerHeight >= courseProductsRef.current.offsetTop) {
                    setSidebarCardVisible(false);
                } else {
                    setSidebarCardVisible(true);
                }
            } else if (courseReviewsRef.current) {
                if (window.scrollY + window.innerHeight >= courseReviewsRef.current.offsetTop) {
                    setSidebarCardVisible(false);
                } else {
                    setSidebarCardVisible(true);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        courseProductsRef,
        courseReviewsRef
    ]);
    if (!courseOverview.thumbnailUrl && !courseOverview.trailerUrl) return null;
    var handleCourseReviewsRefClick = function() {
        if (courseReviewsRef.current) {
            courseReviewsRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    var lecturesCount = 0;
    var url = "";
    var courseDuration = "";
    var quizzesCount = 0;
    var progressValuePercent;
    if (courseOverview != null) {
        lecturesCount = courseOverview.chapters.map(function(chapter) {
            return chapter.lectures;
        }).flat().length;
        url = utils/* getTakeCourseUrl */.uM(courseOverview);
        courseDuration = utils/* formatDurationFromMinutes */.BQ(courseOverview.courseDurationMinutes);
        quizzesCount = courseOverview.chapters.flatMap(function(ch) {
            return ch.lectures;
        }).filter(function(le) {
            return le.lectureType === "QUIZ";
        }).length;
        if (courseOverview.userProgressMetadata) {
            var progressData = courseOverview.userProgressMetadata;
            progressValuePercent = utils/* getCourseProgressPercent */.oD(progressData.lecturesViewed, progressData.courseLecturesCount);
        }
    }
    var handleAuthorClicked = function(authorSlug) {
        router.push(routes/* routes.lektor.slug */._.lektor.slug(authorSlug));
    };
    var renderThubmnailOrTrailer = function() {
        if (courseOverview.trailerUrl) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoWrapper/* default */.Z, {
                vimeoVideoId: courseOverview.trailerUrl
            });
        } else {
            if (!courseOverview.thumbnailUrl) return null;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardImageWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    alt: courseOverview.name,
                    src: courseOverview.thumbnailUrl,
                    layout: "fill",
                    priority: true
                })
            });
        }
    };
    if (courseOverview.slug === "ai") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageContentWrapper/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackLink/* default */.Z, {
                    to: routes/* routes.kurzy.index */._.kurzy.index,
                    text: "Sp\xe4ť na kurzy"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_page, {
                    courseOverview: courseOverview
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageContentWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackLink/* default */.Z, {
                to: routes/* routes.kurzy.index */._.kurzy.index,
                text: "Sp\xe4ť na kurzy"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                direction: "column",
                gap: "24px",
                alignItems: "stretch",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_slug_WrapperFlex, {
                        justifyContent: "space-between",
                        gap: "24px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseDetailsFlex, {
                                direction: "column",
                                alignSelf: "flex-start",
                                alignItems: "flex-start",
                                gap: "24px",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                        variant: "h1",
                                        normalWeight: true,
                                        children: courseOverview.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                        size: "large",
                                        children: courseOverview.shortDescription
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyCourseDescription, {
                                        children: courseOverview.longDescription
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                                        variant: "h3",
                                        normalWeight: true,
                                        children: "Obsah"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(course_CourseContent, {
                                        course: courseOverview
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardFlex, {
                                direction: "column",
                                gap: "12px",
                                alignSelf: "flex-start",
                                sticky: sidebarCardVisible,
                                children: [
                                    renderThubmnailOrTrailer(),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(course_CourseCTAButton, {
                                        user: user,
                                        isLoading: isLoading,
                                        continueUrl: url,
                                        courseOverview: courseOverview
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        alignSelf: "stretch",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                direction: "column",
                                                alignItems: "flex-start",
                                                alignSelf: "flex-start",
                                                gap: "12px",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DifficultyIcon/* default */.Z, {
                                                                difficultyLevel: courseOverview.difficulty.skillLevel
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                children: (ref = courseOverview.difficulty) === null || ref === void 0 ? void 0 : ref.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineClockCircle */.cjn, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                children: courseDuration
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineVideoCamera */.FI4, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                                                children: [
                                                                    lecturesCount,
                                                                    " ",
                                                                    utils/* numOfLecturesText */.Wg(lecturesCount)
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    quizzesCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineQuestionCircle */.KpA, {}),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                                                children: [
                                                                    quizzesCount,
                                                                    " ",
                                                                    utils/* numOfQuizzesText */.pF(quizzesCount)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                direction: "column",
                                                alignItems: "flex-end",
                                                alignSelf: "stretch",
                                                justifyContent: "space-between",
                                                gap: "12px",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                                        direction: "column",
                                                        gap: "12px",
                                                        alignItems: "flex-end",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseInfoItem, {
                                                                clickable: true,
                                                                onClick: handleCourseReviewsRefClick,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating/* default */.Z, {
                                                                    readOnly: true,
                                                                    value: courseOverview.reviewsOverview.averageRating
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoItem, {
                                                                clickable: true,
                                                                onClick: function() {
                                                                    return handleAuthorClicked(courseOverview.author.slug);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
                                                                        altName: courseOverview.author.name,
                                                                        src: courseOverview.author.imageUrl,
                                                                        sizePx: 28,
                                                                        priority: true
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                                        children: courseOverview.author.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    progressValuePercent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoItem, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircullarProgressWithLabel/* default */.Z, {
                                                                size: "28px",
                                                                withoutTextInMiddle: true,
                                                                value: progressValuePercent
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                                                children: [
                                                                    progressValuePercent,
                                                                    "% dokončen\xfdch"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    !progressValuePercent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                                        uppercase: true,
                                                        color: "accent",
                                                        weight: "bold",
                                                        children: (0,CourseCard/* coursePrice */.y)(courseOverview)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    sidebarReviewsVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSidebarCourseReviews, {
                                        courseOverview: courseOverview
                                    }),
                                    sidebarReviewsVisible && courseOverview.reviewsOverview.numberOfReviews > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AllReviewsText, {
                                        color: "accent",
                                        withAccentUnderline: true,
                                        onClick: handleCourseReviewsRefClick,
                                        children: "Zobraziť všetky hodnotenia"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCourseProducts, {
                        course: courseOverview,
                        innerRef: courseProductsRef
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCourseReviews, {
                        courseOverview: courseOverview,
                        innerRef: courseReviewsRef
                    })
                ]
            })
        ]
    });
};
var _slug_WrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5888687d-0"
})(_slug_templateObject(), device/* device.S */.U.S);
var CourseDetailsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5888687d-1"
})(_slug_templateObject1(), device/* device.S */.U.S);
var StyledCourseProducts = (0,styled_components_browser_esm/* default */.ZP)(course_CourseProducts).withConfig({
    componentId: "sc-5888687d-2"
})(_slug_templateObject2());
var StyledCourseReviews = (0,styled_components_browser_esm/* default */.ZP)(course_review_CourseReviews).withConfig({
    componentId: "sc-5888687d-3"
})(_slug_templateObject3());
var CourseInfoItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5888687d-4"
})(_slug_templateObject4(), function(props) {
    return props.clickable ? "pointer" : "unset";
});
var CardFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5888687d-5"
})(_slug_templateObject5(), function(props) {
    return props.sticky ? "sticky" : "static";
}, device/* device.M */.U.M, device/* device.S */.U.S);
var CardImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5888687d-6"
})(_slug_templateObject6());
var StyledSidebarCourseReviews = (0,styled_components_browser_esm/* default */.ZP)(course_review_SidebarCourseReviews).withConfig({
    componentId: "sc-5888687d-7"
})(_slug_templateObject7(), device/* device.S */.U.S);
var AllReviewsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-5888687d-8"
})(_slug_templateObject8(), device/* device.S */.U.S);
var __N_SSG = true;
/* harmony default export */ var _slug_ = (CourseDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,2013,6556,260,7138,3716,4786,7141,874,5270,2566,7391,9774,2888,179], function() { return __webpack_exec__(69442); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);